  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
  //import ListItemText                                        from '@material-ui/core/ListItemText';
  //import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  //import Divider                                             from '@material-ui/core/Divider';
  //import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
  //import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';

  import InputAdornment                                      from '@material-ui/core/InputAdornment';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';

  // import 'babel-polyfill'
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_BillsService }                                 from "../../_services";
  import { wu_CardsService }                                 from "../../_services";
  //------
  // Style
  //------
  import BillsPaymentSetupStyle                                from "./BillsPaymentSetupStyle.jsx";
//-------
// images
//-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import Bills_Company_Placeholder                           from "assets/img/wu/Bills_Company_Placeholder.svg";
  import Bills_header_scan                                   from "assets/img/wu/Bills_header_scan.svg";
  import Card_List_Icon                                      from "assets/img/wu/Card_List_Icon.svg";
  import checkBox_checked                                    from "assets/img/wu/checkBox_checked.svg";
  import checkBox_unchecked                                  from "assets/img/wu/checkBox_unchecked.svg";
  //----------
  // variables
  //----------
  const filename = "BillsPaymentSetup ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var BillsPaymentSetup_continue_locked = true;

class BillsPaymentSetup extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      Bills_header_scan                                    : Bills_header_scan,

      lbl_status                                             : "",
      lbl_date                                               : "",
      imv_logo                                               : "",

      view_D2BInfoText_isHidden                            : true,

      textField10_text                                     : "",
      textField11_text                                     : "",
      textField12_text                                     : "",
      textField13_text                                     : "",
      textField14_text                                     : "",
      textField15_text                                     : "",
      textField16_text                                     : "",
      textField17_text                                     : "",//
      textField10_plh                                      : "",
      textField11_plh                                      : "",
      textField12_plh                                      : "",
      textField13_plh                                      : "",
      textField14_plh                                      : "",
      textField15_plh                                      : "",
      textField16_plh                                      : "",
      textField17_plh                                      : "",
      textField10_isHidden                                 : true,
      textField11_isHidden                                 : true,
      textField12_isHidden                                 : true,
      textField13_isHidden                                 : true,
      textField14_isHidden                                 : true,
      textField15_isHidden                                 : true,
      textField16_isHidden                                 : true,
      textField17_isHidden                                 : true,
      textField10_maxLength                                : 200,
      textField11_maxLength                                : 200,
      textField12_maxLength                                : 200,
      textField13_maxLength                                : 200,
      textField14_maxLength                                : 200,
      textField15_maxLength                                : 200,
      textField16_maxLength                                : 200,
      textField17_maxLength                                : 200,
      textField10_type                                     : "text",
      textField11_type                                     : "text",
      textField12_type                                     : "text",
      textField13_type                                     : "text",
      textField14_type                                     : "text",
      textField15_type                                     : "text",
      textField16_type                                     : "text",
      textField17_type                                     : "text",
      textField10_hasError                                 : false,
      textField11_hasError                                 : false,
      textField12_hasError                                 : false,
      textField13_hasError                                 : false,
      textField14_hasError                                 : false,
      textField15_hasError                                 : false,
      textField16_hasError                                 : false,
      textField17_hasError                                 : false,
      textField10_endorsment                               : "",
      textField11_endorsment                               : "",
      textField12_endorsment                               : "",
      textField13_endorsment                               : "",
      textField14_endorsment                               : "",
      textField15_endorsment                               : "",
      textField16_endorsment                               : "",
      textField17_endorsment                               : "",

      picker10_textFieldLabel1_text                        : "",
      picker11_textFieldLabel1_text                        : "",
      picker12_textFieldLabel1_text                        : "",
      picker13_textFieldLabel1_text                        : "",
      picker14_textFieldLabel1_text                        : "",
      picker15_textFieldLabel1_text                        : "",
      picker16_textFieldLabel1_text                        : "",
      picker17_textFieldLabel1_text                        : "",

      birthDate10                                            : "",   //DatePicker
      birthDate11                                            : "",   //DatePicker
      birthDate12                                            : "",   //DatePicker
      birthDate13                                            : "",   //DatePicker
      birthDate14                                            : "",   //DatePicker
      birthDate15                                            : "",   //DatePicker
      birthDate16                                            : "",   //DatePicker
      birthDate17                                            : "",   //DatePicker

      birthDate10_disabled                                   : false,
      birthDate11_disabled                                   : false,
      birthDate12_disabled                                   : false,
      birthDate13_disabled                                   : false,
      birthDate14_disabled                                   : false,
      birthDate15_disabled                                   : false,
      birthDate16_disabled                                   : false,
      birthDate17_disabled                                   : false,

      birthDate10_hasError                                   : false,
      birthDate11_hasError                                   : false,
      birthDate12_hasError                                   : false,
      birthDate13_hasError                                   : false,
      birthDate14_hasError                                   : false,
      birthDate15_hasError                                   : false,
      birthDate16_hasError                                   : false,
      birthDate17_hasError                                   : false,

      birthDate10_isHidden                                   : true,
      birthDate11_isHidden                                   : true,
      birthDate12_isHidden                                   : true,
      birthDate13_isHidden                                   : true,
      birthDate14_isHidden                                   : true,
      birthDate15_isHidden                                   : true,
      birthDate16_isHidden                                   : true,
      birthDate17_isHidden                                   : true,

      parserObject_getDays10                                 : [],
      parserObject_getDays11                                 : [],
      parserObject_getDays12                                 : [],
      parserObject_getDays13                                 : [],
      parserObject_getDays14                                 : [],
      parserObject_getDays15                                 : [],
      parserObject_getDays16                                 : [],
      parserObject_getDays17                                 : [],

      parserObject_getMonths10                               : [],
      parserObject_getMonths11                               : [],
      parserObject_getMonths12                               : [],
      parserObject_getMonths13                               : [],
      parserObject_getMonths14                               : [],
      parserObject_getMonths15                               : [],
      parserObject_getMonths16                               : [],
      parserObject_getMonths17                               : [],

      parserObject_getYears10                                : [],
      parserObject_getYears11                                : [],
      parserObject_getYears12                                : [],
      parserObject_getYears13                                : [],
      parserObject_getYears14                                : [],
      parserObject_getYears15                                : [],
      parserObject_getYears16                                : [],
      parserObject_getYears17                                : [],

      birthDateDay10_text                                    : "",          //DropDown
      birthDateDay11_text                                    : "",          //DropDown
      birthDateDay12_text                                    : "",          //DropDown
      birthDateDay13_text                                    : "",          //DropDown
      birthDateDay14_text                                    : "",          //DropDown
      birthDateDay15_text                                    : "",          //DropDown
      birthDateDay16_text                                    : "",          //DropDown
      birthDateDay17_text                                    : "",          //DropDown

    //birthDateDay10_id                                      : "",
    //birthDateDay11_id                                      : "",
    //birthDateDay12_id                                      : "",
    //birthDateDay13_id                                      : "",
    //birthDateDay14_id                                      : "",
    //birthDateDay15_id                                      : "",
    //birthDateDay16_id                                      : "",
    //birthDateDay17_id                                      : "",

      birthDateDay10_disabled                                : false,
      birthDateDay11_disabled                                : false,
      birthDateDay12_disabled                                : false,
      birthDateDay13_disabled                                : false,
      birthDateDay14_disabled                                : false,
      birthDateDay15_disabled                                : false,
      birthDateDay16_disabled                                : false,
      birthDateDay17_disabled                                : false,

      birthDateDay10_hasError                                : false,
      birthDateDay11_hasError                                : false,
      birthDateDay12_hasError                                : false,
      birthDateDay13_hasError                                : false,
      birthDateDay14_hasError                                : false,
      birthDateDay15_hasError                                : false,
      birthDateDay16_hasError                                : false,
      birthDateDay17_hasError                                : false,

      birthDateMonth10_text                                  : "",          //DropDown
      birthDateMonth11_text                                  : "",          //DropDown
      birthDateMonth12_text                                  : "",          //DropDown
      birthDateMonth13_text                                  : "",          //DropDown
      birthDateMonth14_text                                  : "",          //DropDown
      birthDateMonth15_text                                  : "",          //DropDown
      birthDateMonth16_text                                  : "",          //DropDown
      birthDateMonth17_text                                  : "",          //DropDown

    //birthDateMonth10_id                                    : "",
    //birthDateMonth11_id                                    : "",
    //birthDateMonth12_id                                    : "",
    //birthDateMonth13_id                                    : "",
    //birthDateMonth14_id                                    : "",
    //birthDateMonth15_id                                    : "",
    //birthDateMonth16_id                                    : "",
    //birthDateMonth17_id                                    : "",

      birthDateMonth10_disabled                              : false,
      birthDateMonth11_disabled                              : false,
      birthDateMonth12_disabled                              : false,
      birthDateMonth13_disabled                              : false,
      birthDateMonth14_disabled                              : false,
      birthDateMonth15_disabled                              : false,
      birthDateMonth16_disabled                              : false,
      birthDateMonth17_disabled                              : false,

      birthDateMonth10_hasError                              : false,
      birthDateMonth11_hasError                              : false,
      birthDateMonth12_hasError                              : false,
      birthDateMonth13_hasError                              : false,
      birthDateMonth14_hasError                              : false,
      birthDateMonth15_hasError                              : false,
      birthDateMonth16_hasError                              : false,
      birthDateMonth17_hasError                              : false,

      birthDateYear10_text                                   : "",          //DropDown
      birthDateYear11_text                                   : "",          //DropDown
      birthDateYear12_text                                   : "",          //DropDown
      birthDateYear13_text                                   : "",          //DropDown
      birthDateYear14_text                                   : "",          //DropDown
      birthDateYear15_text                                   : "",          //DropDown
      birthDateYear16_text                                   : "",          //DropDown
      birthDateYear17_text                                   : "",          //DropDown

    //birthDateYear10_id                                     : "",
    //birthDateYear11_id                                     : "",
    //birthDateYear12_id                                     : "",
    //birthDateYear13_id                                     : "",
    //birthDateYear14_id                                     : "",
    //birthDateYear15_id                                     : "",
    //birthDateYear16_id                                     : "",
    //birthDateYear17_id                                     : "",

      birthDateYear10_disabled                               : false,
      birthDateYear11_disabled                               : false,
      birthDateYear12_disabled                               : false,
      birthDateYear13_disabled                               : false,
      birthDateYear14_disabled                               : false,
      birthDateYear15_disabled                               : false,
      birthDateYear16_disabled                               : false,
      birthDateYear17_disabled                               : false,

      birthDateYear10_hasError                               : false,
      birthDateYear11_hasError                               : false,
      birthDateYear12_hasError                               : false,
      birthDateYear13_hasError                               : false,
      birthDateYear14_hasError                               : false,
      birthDateYear15_hasError                               : false,
      birthDateYear16_hasError                               : false,
      birthDateYear17_hasError                               : false,

      parserObject_bills_payment_info_generic_res          : [],

      parserObject_cards                                   : [],
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                         = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                        = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                                = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                               = this.Snackbar_textField_handleClose.bind(this);

    this.TopRight_scan_act                                            = this.TopRight_scan_act.bind(this);

    this.handleCustomDropDownClick_birthDateDayNN                     = this.handleCustomDropDownClick_birthDateDayNN.bind(this);
    this.handleCustomDropDownClick_birthDateMonthNN                   = this.handleCustomDropDownClick_birthDateMonthNN.bind(this);
    this.handleCustomDropDownClick_birthDateYearNN                    = this.handleCustomDropDownClick_birthDateYearNN.bind(this);
    this.checkBirthDate                                               = this.checkBirthDate.bind(this);

    this.fieldNN_hide                                                 = this.fieldNN_hide.bind(this);
    this.fieldNN_show                                                 = this.fieldNN_show.bind(this);
    this.fillD2bField                                                 = this.fillD2bField.bind(this);

    this.getDateFromPage                                              = this.getDateFromPage.bind(this);

    this.buildUI                                                      = this.buildUI.bind(this);

    this.btn_next_act                                                 = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                                      = this.btn_next_act_isDisabled.bind(this);
    this.makeHTTPConn                                                 = this.makeHTTPConn.bind(this);
    this.makeHTTPConn_cardsList                                       = this.makeHTTPConn_cardsList.bind(this);
    this.makeHTTPConn_next                                            = this.makeHTTPConn_next.bind(this);

    this.get_cardType_FromObj                                         = this.get_cardType_FromObj.bind(this);
    this.get_cardNumMasked_FromObj                                    = this.get_cardNumMasked_FromObj.bind(this);
    this.get_expDatetime_FromObj                                      = this.get_expDatetime_FromObj.bind(this);

    this.IE11_not_loading_state_workaround                            = this.IE11_not_loading_state_workaround.bind(this);
    this.isWebAppIOS12x                                               = this.isWebAppIOS12x.bind(this);

    this.process_CategoriesCompaniesObject                 = this.process_CategoriesCompaniesObject.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+"++++++++++++++++++++++++++++++++++++++++++++++++++");}
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view")+" -> "+localStorage.getItem("curr_view"));}
    if(api.print_logs){console.log(methName+"++++++++++++++++++++++++++++++++++++++++++++++++++");}

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //[Lockers]
    this.stopLockers();

    //-------------
    //Do some reset
    //-------------
    localStorage.setItem("bills_billsHistoryDetail_FLOW","bills_billsHistoryDetail_FLOW_HISTORY");
    try{     Cookies.set('bills_billsHistoryDetail_FLOW',"bills_billsHistoryDetail_FLOW_HISTORY", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="BillsPaymentReview"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      setTimeout(function() {
        this.IE11_not_loading_state_workaround();
      }.bind(this), 200);
      return;
    }
    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    //if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    //-------------------------
    //wu_getCategoriesCompanies---CACHED
    //-------------------------
    let retrieveWSData_getCategoriesCompanies = wu_BillsService.wu_should_getCategoriesCompanies();
    if(api.print_logs){console.log("retrieveWSData_getCategoriesCompanies="+retrieveWSData_getCategoriesCompanies);}
    if(retrieveWSData_getCategoriesCompanies){
      wu_BillsService
      .wu_getCategoriesCompanies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="BillsPaymentSetup"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn_cardsList();
      })
      .catch(err => {
        console.log(methName+"err="+err);
      });
    }
    else{
      try{
        //let res = JSON.parse(localStorage.getItem("categoriescompanies"));
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn_cardsList();
      }catch(err){
        console.log(methName+'err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_cardsList() {
    let methName = filename+"makeHTTPConn_cardsList ";
    if(api.print_logs){console.log(methName);}

    //------------------
    //wu_cards_cardslist
    //------------------
    wu_CardsService
    .wu_cards_cardslist({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="BillsPaymentSetup"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("parserObject_cards_res",JSON.stringify(res.custCardTokenList));
      this.setState({ "parserObject_cards": res.custCardTokenList });
      if(res.custCardTokenList && res.custCardTokenList.length ===0){
        localStorage.setItem("payWithCardMethod", "payWithCardMethod_Normal");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
        localStorage.setItem("parserObject_selectedTokenizedCard", {});
      }
      this.makeHTTPConn();
    })
    .catch(err => {
      this.stopSpinners();
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn() {
    let methName = filename+"makeHTTPConn ";
    if(api.print_logs){console.log(methName);}

    //var parserObject_bills_billsHistoryDetail_res = null;
    //try{ parserObject_bills_billsHistoryDetail_res = JSON.parse(localStorage.getItem("parserObject_bills_billsHistoryDetail_res"));}catch(err){console.log(methName+'err='+err);}

    var billPaymentSetup_ws = localStorage.getItem("billPaymentSetup_ws");
    if(api.print_logs){console.log(methName+"billPaymentSetup_ws="+billPaymentSetup_ws);}

    if(billPaymentSetup_ws === "inputSingleRF"){
        let parserObject_bills_payment_info_generic_res = [];
        try{ parserObject_bills_payment_info_generic_res = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_res")) ;}catch(err){console.log(methName+'err='+err);} console.log("parserObject_bills_payment_info_generic_res="+JSON.stringify(parserObject_bills_payment_info_generic_res));
        this.setState({ "parserObject_bills_payment_info_generic_res": parserObject_bills_payment_info_generic_res });
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        setTimeout(function() {
          this.buildUI();
        }.bind(this), 100);
        return;
    }
    else if(billPaymentSetup_ws === "scanSingleRF"){
        let parserObject_bills_payment_info_generic_res = [];
        try{ parserObject_bills_payment_info_generic_res = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_res")) ;}catch(err){console.log(methName+'err='+err);}
        this.setState({ "parserObject_bills_payment_info_generic_res": parserObject_bills_payment_info_generic_res });
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        setTimeout(function() {
          this.buildUI();
        }.bind(this), 100);
        return;
    }
    else if(billPaymentSetup_ws === "scanBillerRF"){
        let parserObject_bills_payment_info_generic_res = [];
        try{ parserObject_bills_payment_info_generic_res = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_res")) ;}catch(err){console.log(methName+'err='+err);}
        this.setState({ "parserObject_bills_payment_info_generic_res": parserObject_bills_payment_info_generic_res });
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        setTimeout(function() {
          this.buildUI();
        }.bind(this), 100);
        return;
    }
    else{
      var parserObject_bills_payment_info_billPayment_req = null;
      try{ parserObject_bills_payment_info_billPayment_req = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_billPayment_req"));}catch(err){console.log(methName+'err='+err);}
      console.log(methName+"parserObject_bills_payment_info_billPayment_req="+parserObject_bills_payment_info_billPayment_req);

      //---------------------------
      //wu_bills_billshistoryDetail
      //---------------------------
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_BillsService
      .wu_bills_info_billPayment(parserObject_bills_payment_info_billPayment_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="BillsPaymentSetup"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        var parserObject_bills_payment_info_generic_res = res.fields;
        parserObject_bills_payment_info_generic_res.sort(function(a, b) {
          if( (a.order+"").localeCompare(b.order+"") === -1){ return -1; }
          if( (a.order+"").localeCompare(b.order+"") === 1){ return 1; }
          return 0;
        });
        localStorage.setItem("parserObject_bills_payment_info_generic_res", JSON.stringify(parserObject_bills_payment_info_generic_res));
        this.setState({ "parserObject_bills_payment_info_generic_res": parserObject_bills_payment_info_generic_res });

        this.buildUI();
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        return;
      })
      .catch(err => {
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
          this.dialog_handleOpen(err.returnText);
        }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    const defaultPropsDay10 = { options : this.state.parserObject_getDays10, getOptionLabel : option => option, };
    const defaultPropsDay11 = { options : this.state.parserObject_getDays11, getOptionLabel : option => option, };
    const defaultPropsDay12 = { options : this.state.parserObject_getDays12, getOptionLabel : option => option, };
    const defaultPropsDay13 = { options : this.state.parserObject_getDays13, getOptionLabel : option => option, };
    const defaultPropsDay14 = { options : this.state.parserObject_getDays14, getOptionLabel : option => option, };
    const defaultPropsDay15 = { options : this.state.parserObject_getDays15, getOptionLabel : option => option, };
    const defaultPropsDay16 = { options : this.state.parserObject_getDays16, getOptionLabel : option => option, };
    const defaultPropsDay17 = { options : this.state.parserObject_getDays17, getOptionLabel : option => option, };

    const defaultPropsMonth10 = { options: this.state.parserObject_getMonths10, getOptionLabel : option => option, };
    const defaultPropsMonth11 = { options: this.state.parserObject_getMonths11, getOptionLabel : option => option, };
    const defaultPropsMonth12 = { options: this.state.parserObject_getMonths12, getOptionLabel : option => option, };
    const defaultPropsMonth13 = { options: this.state.parserObject_getMonths13, getOptionLabel : option => option, };
    const defaultPropsMonth14 = { options: this.state.parserObject_getMonths14, getOptionLabel : option => option, };
    const defaultPropsMonth15 = { options: this.state.parserObject_getMonths15, getOptionLabel : option => option, };
    const defaultPropsMonth16 = { options: this.state.parserObject_getMonths16, getOptionLabel : option => option, };
    const defaultPropsMonth17 = { options: this.state.parserObject_getMonths17, getOptionLabel : option => option, };

    const defaultPropsYear10 = { options : this.state.parserObject_getYears10, getOptionLabel : option => option, };
    const defaultPropsYear11 = { options : this.state.parserObject_getYears11, getOptionLabel : option => option, };
    const defaultPropsYear12 = { options : this.state.parserObject_getYears12, getOptionLabel : option => option, };
    const defaultPropsYear13 = { options : this.state.parserObject_getYears13, getOptionLabel : option => option, };
    const defaultPropsYear14 = { options : this.state.parserObject_getYears14, getOptionLabel : option => option, };
    const defaultPropsYear15 = { options : this.state.parserObject_getYears15, getOptionLabel : option => option, };
    const defaultPropsYear16 = { options : this.state.parserObject_getYears16, getOptionLabel : option => option, };
    const defaultPropsYear17 = { options : this.state.parserObject_getYears17, getOptionLabel : option => option, };

    let mobileOpen = (window.innerWidth < 960) ? true : false; //console.log("mobileOpen="+mobileOpen);
    let TextField_label_fontSize = mobileOpen ? "0.76rem" : "1.0rem";

    return (
      <div className={classes.container}>
      <div id="refreshHelper"> </div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={api.columns_bills_sm} md={api.columns_bills_md}>
            {/* -------------------------------- */}
            {/* ----------[yellow Header]------- */}
            {/* -------------------------------- */}
            <div style={{marginTop:20, marginBottom:10}}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 0 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("BillsPaymentSetup_title")}</div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
            {/* ------------------------- */}
            {/* ----------Comapny logo--- */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              {/*
              <GridItem xs={10} sm={10} md={10}>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div style={{width:"100%", display:"inline-block", marginTop:10, padding:0, textAlign:"right", marginRight:0 }}>
                  <Button onClick={this.TopRight_scan_act}><div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_scan} alt=""/></div></Button>
                </div>
              </GridItem> */}
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.BillsPaymentSetupStyle_lbl_status}>{this.state.lbl_status}</div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.BillsPaymentSetupStyle_lbl_date}>{this.state.lbl_date}</div>
              </GridItem>
              {this.state.imv_logo !== "" && this.state.imv_logo.indexOf(".png") > -1 ?
              <GridItem xs={2} sm={2} md={2}>
                <GridContainer justify="center">
                  <div className={classes.logo}><img src={this.state.imv_logo} alt="" /></div>
                </GridContainer>
              </GridItem>
              :
              (
              <GridItem xs={2} sm={2} md={2}>
                <GridContainer justify="center">
                  <div className={classes.companyIcon}><img src={Bills_Company_Placeholder} alt="companyIcon" /></div>
                </GridContainer>
              </GridItem>
              )}
            </GridContainer>
            {/* ------------------------------------------------- */}
            {/* ----------D2B TextField(1-10)-------------------- */}
            {/* ------------------------------------------------- */}
            <GridContainer justify="center">
              {this.state.textField10_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField10_hasError}
                    className={classes.textField10}
                    id="textField10"
                    label={this.state.textField10_plh}
                    value={this.state.textField10_text}
                    InputProps={{ onChange: event => this.change(event, "textField10_text"), type: this.state.textField10_type, maxLength: this.state.textField10_maxLength, endAdornment: <InputAdornment position="end">{this.state.textField10_endorsment}</InputAdornment>}}
                    InputLabelProps={{style:{ fontSize:TextField_label_fontSize} }}
                  />
                </GridItem>
              )}
              {this.state.textField11_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField11_hasError}
                    className={classes.textField11}
                    id="textField11"
                    label={this.state.textField11_plh}
                    value={this.state.textField11_text}
                    InputProps={{ onChange: event => this.change(event, "textField11_text"), type: this.state.textField11_type, maxLength: this.state.textField11_maxLength, endAdornment: <InputAdornment position="end">{this.state.textField11_endorsment}</InputAdornment>}}
                    InputLabelProps={{style:{ fontSize:TextField_label_fontSize} }}
                  />
                </GridItem>
              )}
              {this.state.textField12_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField12_hasError}
                    className={classes.textField12}
                    id="textField12"
                    label={this.state.textField12_plh}
                    value={this.state.textField12_text}
                    InputProps={{ onChange: event => this.change(event, "textField12_text"), type: this.state.textField12_type, maxLength: this.state.textField12_maxLength, endAdornment: <InputAdornment position="end">{this.state.textField12_endorsment}</InputAdornment>}}
                    InputLabelProps={{style:{ fontSize:TextField_label_fontSize} }}
                  />
                </GridItem>
              )}
              {this.state.textField13_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField13_hasError}
                    className={classes.textField13}
                    id="textField13"
                    label={this.state.textField13_plh}
                    value={this.state.textField13_text}
                    InputProps={{ onChange: event => this.change(event, "textField13_text"), type: this.state.textField13_type, maxLength: this.state.textField13_maxLength, endAdornment: <InputAdornment position="end">{this.state.textField13_endorsment}</InputAdornment>}}
                    InputLabelProps={{style:{ fontSize:TextField_label_fontSize} }}
                  />
                </GridItem>
              )}
              {this.state.textField14_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField14_hasError}
                    className={classes.textField14}
                    id="textField14"
                    label={this.state.textField14_plh}
                    value={this.state.textField14_text}
                    InputProps={{ onChange: event => this.change(event, "textField14_text"), type: this.state.textField14_type, maxLength: this.state.textField14_maxLength, endAdornment: <InputAdornment position="end">{this.state.textField14_endorsment}</InputAdornment>}}
                    InputLabelProps={{style:{ fontSize:TextField_label_fontSize} }}
                  />
                </GridItem>
              )}
              {this.state.textField15_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField15_hasError}
                    className={classes.textField15}
                    id="textField15"
                    label={this.state.textField15_plh}
                    value={this.state.textField15_text}
                    InputProps={{ onChange: event => this.change(event, "textField15_text"), type: this.state.textField15_type, maxLength: this.state.textField15_maxLength, endAdornment: <InputAdornment position="end">{this.state.textField15_endorsment}</InputAdornment>}}
                    InputLabelProps={{style:{ fontSize:TextField_label_fontSize} }}
                  />
                </GridItem>
              )}
              {this.state.textField16_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField16_hasError}
                    className={classes.textField16}
                    id="textField16"
                    label={this.state.textField16_plh}
                    value={this.state.textField16_text}
                    InputProps={{ onChange: event => this.change(event, "textField16_text"), type: this.state.textField16_type, maxLength: this.state.textField16_maxLength, endAdornment: <InputAdornment position="end">{this.state.textField16_endorsment}</InputAdornment>}}
                    InputLabelProps={{style:{ fontSize:TextField_label_fontSize} }}
                  />
                </GridItem>
              )}
              {this.state.textField17_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField17_hasError}
                    className={classes.textField17}
                    id="textField17"
                    label={this.state.textField17_plh}
                    value={this.state.textField17_text}
                    InputProps={{ onChange: event => this.change(event, "textField17_text"), type: this.state.textField17_type, maxLength: this.state.textField17_maxLength, endAdornment: <InputAdornment position="end">{this.state.textField17_endorsment}</InputAdornment>}}
                    InputLabelProps={{style:{ fontSize:TextField_label_fontSize} }}
                  />
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------Bills Dates(10)------------------------ */}
              {/* ------------------------------------------------- */}
              {this.state.birthDate10_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}><div className={classes.label1}>{this.getFieldValueString(0,"name")}</div></GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay10}
                          disabled={this.state.birthDateDay10_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay10_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDayNN(event,value,10)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay10_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth10}
                          disabled={this.state.birthDateMonth10_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth10_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonthNN(event,value,10)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth10_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear10}
                          disabled={this.state.birthDateYear10_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear10_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYearNN(event,value,10)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear10_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------Bills Dates(11)------------------------ */}
              {/* ------------------------------------------------- */}
              {this.state.birthDate11_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}><div className={classes.label1}>{this.getFieldValueString(1,"name")}</div></GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay11}
                          disabled={this.state.birthDateDay11_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay11_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDayNN(event,value,11)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay11_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth11}
                          disabled={this.state.birthDateMonth11_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth11_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonthNN(event,value,11)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth11_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear11}
                          disabled={this.state.birthDateYear11_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear11_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYearNN(event,value,11)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear11_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------Bills Dates(12)------------------------ */}
              {/* ------------------------------------------------- */}
              {this.state.birthDate12_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}><div className={classes.label1}>{this.getFieldValueString(2,"name")}</div></GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay12}
                          disabled={this.state.birthDateDay12_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay12_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDayNN(event,value,12)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay12_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth12}
                          disabled={this.state.birthDateMonth12_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth12_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonthNN(event,value,12)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth12_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear12}
                          disabled={this.state.birthDateYear12_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear12_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYearNN(event,value,12)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear12_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------Bills Dates(13)------------------------ */}
              {/* ------------------------------------------------- */}
              {this.state.birthDate13_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}><div className={classes.label1}>{this.getFieldValueString(3,"name")}</div></GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay13}
                          disabled={this.state.birthDateDay13_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay13_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDayNN(event,value,13)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay13_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth13}
                          disabled={this.state.birthDateMonth13_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth13_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonthNN(event,value,13)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth13_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear13}
                          disabled={this.state.birthDateYear13_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear13_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYearNN(event,value,13)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear13_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------Bills Dates(14)------------------------ */}
              {/* ------------------------------------------------- */}
              {this.state.birthDate14_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}><div className={classes.label1}>{this.getFieldValueString(4,"name")}</div></GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay14}
                          disabled={this.state.birthDateDay14_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay14_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDayNN(event,value,14)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay14_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth14}
                          disabled={this.state.birthDateMonth14_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth14_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonthNN(event,value,14)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth14_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear14}
                          disabled={this.state.birthDateYear14_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear14_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYearNN(event,value,14)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear14_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------Bills Dates(15)------------------------ */}
              {/* ------------------------------------------------- */}
              {this.state.birthDate15_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}><div className={classes.label1}>{this.getFieldValueString(5,"name")}</div></GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay15}
                          disabled={this.state.birthDateDay15_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay15_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDayNN(event,value,15)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay15_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth15}
                          disabled={this.state.birthDateMonth15_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth15_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonthNN(event,value,15)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth15_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear15}
                          disabled={this.state.birthDateYear15_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear15_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYearNN(event,value,15)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear15_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------Bills Dates(16)------------------------ */}
              {/* ------------------------------------------------- */}
              {this.state.birthDate16_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}><div className={classes.label1}>{this.getFieldValueString(6,"name")}</div></GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay16}
                          disabled={this.state.birthDateDay16_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay16_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDayNN(event,value,16)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay16_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth16}
                          disabled={this.state.birthDateMonth16_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth16_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonthNN(event,value,16)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth16_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear16}
                          disabled={this.state.birthDateYear16_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear16_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYearNN(event,value,16)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear16_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------Bills Dates(17)------------------------ */}
              {/* ------------------------------------------------- */}
              {this.state.birthDate17_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} style={{ marginBottom:0,marginTop:10 }}><div className={classes.label1}>{this.getFieldValueString(7,"name")}</div></GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_d}>
                      <FormControl fullWidth className={classes.birthDateDay}>
                        <Autocomplete
                          {...defaultPropsDay17}
                          disabled={this.state.birthDateDay17_disabled}
                          id="birthDateDayId"
                          value={this.state.birthDateDay17_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateDayNN(event,value,17)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateDay17_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_d")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_m}>
                      <FormControl fullWidth className={classes.birthDateMonth}>
                        <Autocomplete
                          {...defaultPropsMonth17}
                          disabled={this.state.birthDateMonth17_disabled}
                          id="birthDateMonthId"
                          value={this.state.birthDateMonth17_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateMonthNN(event,value,17)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateMonth17_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_m")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={4} className={classes.GridItemLocal_y}>
                      <FormControl fullWidth className={classes.birthDateYear}>
                        <Autocomplete
                          {...defaultPropsYear17}
                          disabled={this.state.birthDateYear17_disabled}
                          id="birthDateYearId"
                          value={this.state.birthDateYear17_text}
                          disableClearable
                          onChange={(event,value) => this.handleCustomDropDownClick_birthDateYearNN(event,value,17)}
                          renderInput={params => <TextField {...params} error={this.state.birthDateYear17_hasError} label={this.NSInforString("SettingsProfilePersonal_plh07_y")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
              )}
            </GridContainer>

            {this.state.parserObject_cards.length === 0 ? ( "" ) : (
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ marginTop: 20, marginBottom: 0  }}>
                  <div className={classes.label2}>{this.NSInforString("TransferOnlineCards_lbl_lb2")}</div>
                </div>
              </GridItem>
            </GridContainer>
            )}

            {this.state.parserObject_cards.length !== 0 && localStorage.getItem("mobileOpen")==="true" ? (
            <div style={{marginBottom:20}}>
              <List component="nav" aria-label="main mailbox folders">
                {this.state.parserObject_cards.map(e => (
                  <React.Fragment key={"fragmentId_"+e.token}>
                    <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_card(e)}>
                      <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:0, paddingRight:0}}>
                        <GridItem xs={2} sm={2} md={2}>
                          <GridContainer justify="center" style={{paddingTop:30, paddingLeft:10}}>
                            <div className={classes.Card_List_Icon_mobile}><img src={Card_List_Icon} alt="Card_List_Icon_mobile" /></div>
                          </GridContainer>
                        </GridItem>
                        <GridItem xs={8} sm={8} md={8}>
                          <GridContainer justify="center" style={{paddingTop:25, paddingLeft:0}}>
                            <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_cardType}>{this.get_cardType_FromObj(e)}</div></GridItem>
                            <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_other}>{this.get_cardNumMasked_FromObj(e)}&nbsp;&nbsp;&nbsp;&nbsp;{this.get_expDatetime_FromObj(e)}</div></GridItem>
                          </GridContainer>
                        </GridItem>
                        <GridItem xs={2} sm={2} md={2}>
                          <GridContainer justify="center" style={{paddingTop:40, paddingRight:0}}>
                            <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_mobile}><img src={e.preSelected===true ? checkBox_checked : checkBox_unchecked} alt="checkBox_Icon_mobile" /></div></GridItem>
                          </GridContainer>
                        </GridItem>
                      </GridContainer>
                    </ListItem>
                  </React.Fragment>
                ))}
                <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_newCard({})}>
                  <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:0, paddingRight:0}}>
                    <GridItem xs={2} sm={2} md={2}>
                      <GridContainer justify="center" style={{paddingTop:30, paddingLeft:10}}>
                        <div className={classes.Card_List_Icon_mobile}><img src={Card_List_Icon} alt="Card_List_Icon_mobile" /></div>
                      </GridContainer>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={8}>
                      <GridContainer justify="center" style={{paddingTop:25, paddingLeft:5}}>
                        {this.state.checkBox_newCard===true ? (
                          <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_newCard_checked}>{this.NSInforString("BillsPaymentSetup_lbl_newCard")}</div></GridItem>
                        ) : (
                          <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_newCard}>{this.NSInforString("BillsPaymentSetup_lbl_newCard")}</div></GridItem>
                        )}
                      </GridContainer>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <GridContainer justify="center" style={{paddingTop:40, paddingRight:0}}>
                        {this.state.checkBox_newCard===true ? (
                          <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_mobile}><img src={checkBox_checked} alt="checkBox_Icon_mobile" /></div></GridItem>
                        ) : (
                          <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_mobile}><img src={checkBox_unchecked} alt="checkBox_Icon_mobile" /></div></GridItem>
                        )}
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </ListItem>
              </List>
            </div>
            ) : ( "" )}

            {this.state.parserObject_cards.length !== 0 && localStorage.getItem("mobileOpen")!=="true" ? (
            <div style={{marginBottom:20}}>
              <List component="nav" aria-label="main mailbox folders">
                {this.state.parserObject_cards.map(e => (
                  <React.Fragment key={"fragmentId_"+e.token}>
                    <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_card(e)}>
                      <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:0, paddingRight:0}}>
                        <GridItem xs={3} sm={3} md={3}>
                          <GridContainer justify="center" style={{paddingTop:18, paddingLeft:10}}>
                            <div className={classes.Card_List_Icon_desktop}><img src={Card_List_Icon} alt="Card_List_Icon" /></div>
                          </GridContainer>
                        </GridItem>
                        <GridItem xs={7} sm={7} md={7}>
                          <GridContainer justify="center" style={{paddingTop:25, paddingLeft:0}}>
                            <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_cardType}>{this.get_cardType_FromObj(e)}</div></GridItem>
                            <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_other}>{this.get_cardNumMasked_FromObj(e)}&nbsp;&nbsp;&nbsp;&nbsp;{this.get_expDatetime_FromObj(e)}</div></GridItem>
                          </GridContainer>
                        </GridItem>
                        <GridItem xs={2} sm={2} md={2}>
                          <GridContainer justify="center" style={{paddingTop:38, paddingRight:0}}>
                            <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_desktop}><img src={e.preSelected===true ? checkBox_checked : checkBox_unchecked} alt="checkBox_Icon_desktop" /></div></GridItem>
                          </GridContainer>
                        </GridItem>
                      </GridContainer>
                    </ListItem>
                  </React.Fragment>
                ))}
                <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_newCard({})}>
                  <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:0, paddingRight:0}}>
                    <GridItem xs={3} sm={3} md={3}>
                      <GridContainer justify="center" style={{paddingTop:18, paddingLeft:10}}>
                        <div className={classes.Card_List_Icon_desktop}><img src={Card_List_Icon} alt="Card_List_Icon" /></div>
                      </GridContainer>
                    </GridItem>
                    <GridItem xs={7} sm={7} md={7}>
                      <GridContainer justify="center" style={{paddingTop:35, paddingLeft:0}}>
                        {this.state.checkBox_newCard===true ? (
                          <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_newCard_checked}>{this.NSInforString("BillsPaymentSetup_lbl_newCard")}</div></GridItem>
                        ) : (
                          <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_newCard}>{this.NSInforString("BillsPaymentSetup_lbl_newCard")}</div></GridItem>
                        )}
                      </GridContainer>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <GridContainer justify="center" style={{paddingTop:38, paddingRight:0}}>
                        {this.state.checkBox_newCard===true ? (
                          <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_desktop}><img src={checkBox_checked} alt="checkBox_Icon_desktop" /></div></GridItem>
                        ) : (
                          <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_desktop}><img src={checkBox_unchecked} alt="checkBox_Icon_desktop" /></div></GridItem>
                        )}
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </ListItem>
              </List>
            </div>
            ) : ( "" )}
            {/* -------------------------------------------------- */}
            {/* ----------[Spinner Inline]------------------------ */}
            {/* -------------------------------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    disabled={this.btn_next_act_isDisabled()}
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.btn_next_act}
                    type="submit">
                    {this.NSInforString("BillsPaymentSetup_btn_continue")}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------[goBack Bottom]------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("BillsPaymentSetup_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div id="dialog">
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[Spinner Dialog]------------------------ */}
        {/* -------------------------------------------------- */}
        <div id="spinnerDialog">
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  buildUI(){
      let methName = filename+"buildUI ";
      if(api.print_logs){console.log(methName);}

      var parserObject_categoriesCompaniesList = null;
      try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

      var ws_billId = 0;
      try{ ws_billId = parseInt(localStorage.getItem("bills_billerId"));}catch(err){console.log(methName+'err='+err);}

      var imageURL = api.url + wu_Utilities.bills_images_urls(ws_billId,parserObject_categoriesCompaniesList);
      if(api.print_logs){console.log(methName+"imageURL="+imageURL);}

      let d2bCnt = this.state.parserObject_bills_payment_info_generic_res.length;

      let textField10_plh = ""; let picker10_textFieldLabel1_text = "";
      let textField11_plh = ""; let picker11_textFieldLabel1_text = "";
      let textField12_plh = ""; let picker12_textFieldLabel1_text = "";
      let textField13_plh = ""; let picker13_textFieldLabel1_text = "";
      let textField14_plh = ""; let picker14_textFieldLabel1_text = "";
      let textField15_plh = ""; let picker15_textFieldLabel1_text = "";
      let textField16_plh = ""; let picker16_textFieldLabel1_text = "";
      let textField17_plh = ""; let picker17_textFieldLabel1_text = "";
      if(api.print_logs){console.log(methName+"step1");}

      if(d2bCnt>0){ try{ textField10_plh = this.state.parserObject_bills_payment_info_generic_res[0]["name"];  picker10_textFieldLabel1_text = this.state.parserObject_bills_payment_info_generic_res[0]["name"];  }catch(err){ ; } }
      if(d2bCnt>1){ try{ textField11_plh = this.state.parserObject_bills_payment_info_generic_res[1]["name"];  picker11_textFieldLabel1_text = this.state.parserObject_bills_payment_info_generic_res[1]["name"];  }catch(err){ ; } }
      if(d2bCnt>2){ try{ textField12_plh = this.state.parserObject_bills_payment_info_generic_res[2]["name"];  picker12_textFieldLabel1_text = this.state.parserObject_bills_payment_info_generic_res[2]["name"];  }catch(err){ ; } }
      if(d2bCnt>3){ try{ textField13_plh = this.state.parserObject_bills_payment_info_generic_res[3]["name"];  picker13_textFieldLabel1_text = this.state.parserObject_bills_payment_info_generic_res[3]["name"];  }catch(err){ ; } }
      if(d2bCnt>4){ try{ textField14_plh = this.state.parserObject_bills_payment_info_generic_res[4]["name"];  picker14_textFieldLabel1_text = this.state.parserObject_bills_payment_info_generic_res[4]["name"];  }catch(err){ ; } }
      if(d2bCnt>5){ try{ textField15_plh = this.state.parserObject_bills_payment_info_generic_res[5]["name"];  picker15_textFieldLabel1_text = this.state.parserObject_bills_payment_info_generic_res[5]["name"];  }catch(err){ ; } }
      if(d2bCnt>6){ try{ textField16_plh = this.state.parserObject_bills_payment_info_generic_res[6]["name"];  picker16_textFieldLabel1_text = this.state.parserObject_bills_payment_info_generic_res[6]["name"];  }catch(err){ ; } }
      if(d2bCnt>7){ try{ textField17_plh = this.state.parserObject_bills_payment_info_generic_res[7]["name"];  picker17_textFieldLabel1_text = this.state.parserObject_bills_payment_info_generic_res[7]["name"];  }catch(err){ ; } }
      if(api.print_logs){console.log(methName+"step2a");}

      let fieldLength_10 = 200; if(d2bCnt>0) { try{ fieldLength_10 = parseInt(this.state.parserObject_bills_payment_info_generic_res[0]["length"]);  }catch(err){ fieldLength_10 = 200; } }
      let fieldLength_11 = 200; if(d2bCnt>1) { try{ fieldLength_11 = parseInt(this.state.parserObject_bills_payment_info_generic_res[1]["length"]);  }catch(err){ fieldLength_11 = 200; } }
      let fieldLength_12 = 200; if(d2bCnt>2) { try{ fieldLength_12 = parseInt(this.state.parserObject_bills_payment_info_generic_res[2]["length"]);  }catch(err){ fieldLength_12 = 200; } }
      let fieldLength_13 = 200; if(d2bCnt>3) { try{ fieldLength_13 = parseInt(this.state.parserObject_bills_payment_info_generic_res[3]["length"]);  }catch(err){ fieldLength_13 = 200; } }
      let fieldLength_14 = 200; if(d2bCnt>4) { try{ fieldLength_14 = parseInt(this.state.parserObject_bills_payment_info_generic_res[4]["length"]);  }catch(err){ fieldLength_14 = 200; } }
      let fieldLength_15 = 200; if(d2bCnt>5) { try{ fieldLength_15 = parseInt(this.state.parserObject_bills_payment_info_generic_res[5]["length"]);  }catch(err){ fieldLength_15 = 200; } }
      let fieldLength_16 = 200; if(d2bCnt>6) { try{ fieldLength_16 = parseInt(this.state.parserObject_bills_payment_info_generic_res[6]["length"]);  }catch(err){ fieldLength_16 = 200; } }
      let fieldLength_17 = 200; if(d2bCnt>7) { try{ fieldLength_17 = parseInt(this.state.parserObject_bills_payment_info_generic_res[7]["length"]);  }catch(err){ fieldLength_17 = 200; } }
      if(api.print_logs){console.log(methName+"step2b");}

      let endAdornment_10 = ""; if(d2bCnt>0) { try{ endAdornment_10 = this.state.parserObject_bills_payment_info_generic_res[0]["type"]==="AMOUNT" ? "EUR" : "";  }catch(err){ endAdornment_10 = ""; } }
      let endAdornment_11 = ""; if(d2bCnt>1) { try{ endAdornment_11 = this.state.parserObject_bills_payment_info_generic_res[1]["type"]==="AMOUNT" ? "EUR" : "";  }catch(err){ endAdornment_11 = ""; } }
      let endAdornment_12 = ""; if(d2bCnt>2) { try{ endAdornment_12 = this.state.parserObject_bills_payment_info_generic_res[2]["type"]==="AMOUNT" ? "EUR" : "";  }catch(err){ endAdornment_12 = ""; } }
      let endAdornment_13 = ""; if(d2bCnt>3) { try{ endAdornment_13 = this.state.parserObject_bills_payment_info_generic_res[3]["type"]==="AMOUNT" ? "EUR" : "";  }catch(err){ endAdornment_13 = ""; } }
      let endAdornment_14 = ""; if(d2bCnt>4) { try{ endAdornment_14 = this.state.parserObject_bills_payment_info_generic_res[4]["type"]==="AMOUNT" ? "EUR" : "";  }catch(err){ endAdornment_14 = ""; } }
      let endAdornment_15 = ""; if(d2bCnt>5) { try{ endAdornment_15 = this.state.parserObject_bills_payment_info_generic_res[5]["type"]==="AMOUNT" ? "EUR" : "";  }catch(err){ endAdornment_15 = ""; } }
      let endAdornment_16 = ""; if(d2bCnt>6) { try{ endAdornment_16 = this.state.parserObject_bills_payment_info_generic_res[6]["type"]==="AMOUNT" ? "EUR" : "";  }catch(err){ endAdornment_16 = ""; } }
      let endAdornment_17 = ""; if(d2bCnt>7) { try{ endAdornment_17 = this.state.parserObject_bills_payment_info_generic_res[7]["type"]==="AMOUNT" ? "EUR" : "";  }catch(err){ endAdornment_17 = ""; } }
      if(api.print_logs){console.log(methName+"step2c");}

      let required_10 = false; if(d2bCnt>0) { try{ required_10 = this.state.parserObject_bills_payment_info_generic_res[0]["required"];  }catch(err){ ; } }
      let required_11 = false; if(d2bCnt>1) { try{ required_11 = this.state.parserObject_bills_payment_info_generic_res[1]["required"];  }catch(err){ ; } }
      let required_12 = false; if(d2bCnt>2) { try{ required_12 = this.state.parserObject_bills_payment_info_generic_res[2]["required"];  }catch(err){ ; } }
      let required_13 = false; if(d2bCnt>3) { try{ required_13 = this.state.parserObject_bills_payment_info_generic_res[3]["required"];  }catch(err){ ; } }
      let required_14 = false; if(d2bCnt>4) { try{ required_14 = this.state.parserObject_bills_payment_info_generic_res[4]["required"];  }catch(err){ ; } }
      let required_15 = false; if(d2bCnt>5) { try{ required_15 = this.state.parserObject_bills_payment_info_generic_res[5]["required"];  }catch(err){ ; } }
      let required_16 = false; if(d2bCnt>6) { try{ required_16 = this.state.parserObject_bills_payment_info_generic_res[6]["required"];  }catch(err){ ; } }
      let required_17 = false; if(d2bCnt>7) { try{ required_17 = this.state.parserObject_bills_payment_info_generic_res[7]["required"];  }catch(err){ ; } }
      if(api.print_logs){console.log(methName+"step3");}

      let optionalStr = (localStorage.getItem("lang")==="en") ?  "(Optional)" : "(Προαιρετικό)";
      if(d2bCnt>0) { try{ textField10_plh = (required_10) ? textField10_plh : textField10_plh+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>1) { try{ textField11_plh = (required_11) ? textField11_plh : textField11_plh+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>2) { try{ textField12_plh = (required_12) ? textField12_plh : textField12_plh+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>3) { try{ textField13_plh = (required_13) ? textField13_plh : textField13_plh+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>4) { try{ textField14_plh = (required_14) ? textField14_plh : textField14_plh+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>5) { try{ textField15_plh = (required_15) ? textField15_plh : textField15_plh+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>6) { try{ textField16_plh = (required_16) ? textField16_plh : textField16_plh+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>7) { try{ textField17_plh = (required_17) ? textField17_plh : textField17_plh+" "+optionalStr; }catch(err){ ; } }
      if(api.print_logs){console.log(methName+"step4");}

      if(d2bCnt>0) { try{ picker10_textFieldLabel1_text = (required_10) ? picker10_textFieldLabel1_text : picker10_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>1) { try{ picker11_textFieldLabel1_text = (required_11) ? picker11_textFieldLabel1_text : picker11_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>2) { try{ picker12_textFieldLabel1_text = (required_12) ? picker12_textFieldLabel1_text : picker12_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>3) { try{ picker13_textFieldLabel1_text = (required_13) ? picker13_textFieldLabel1_text : picker13_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>4) { try{ picker14_textFieldLabel1_text = (required_14) ? picker14_textFieldLabel1_text : picker14_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>5) { try{ picker15_textFieldLabel1_text = (required_15) ? picker15_textFieldLabel1_text : picker15_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>6) { try{ picker16_textFieldLabel1_text = (required_16) ? picker16_textFieldLabel1_text : picker16_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
      if(d2bCnt>7) { try{ picker17_textFieldLabel1_text = (required_17) ? picker17_textFieldLabel1_text : picker17_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
      if(api.print_logs){console.log(methName+"step5");}

      this.setState({
        "lbl_status"                 : wu_Utilities.bills_companyNameFromBillId(ws_billId, parserObject_categoriesCompaniesList),
        "lbl_date"                   : "",
        "imv_logo"                   : imageURL,

        "textField10_plh":textField10_plh, "picker10_textFieldLabel1_text":picker10_textFieldLabel1_text.trim(), "textField10_maxLength":fieldLength_10, "textField10_endorsment":endAdornment_10,
        "textField11_plh":textField11_plh, "picker11_textFieldLabel1_text":picker11_textFieldLabel1_text.trim(), "textField11_maxLength":fieldLength_11, "textField11_endorsment":endAdornment_11,
        "textField12_plh":textField12_plh, "picker12_textFieldLabel1_text":picker12_textFieldLabel1_text.trim(), "textField12_maxLength":fieldLength_12, "textField12_endorsment":endAdornment_12,
        "textField13_plh":textField13_plh, "picker13_textFieldLabel1_text":picker13_textFieldLabel1_text.trim(), "textField13_maxLength":fieldLength_13, "textField13_endorsment":endAdornment_13,
        "textField14_plh":textField14_plh, "picker14_textFieldLabel1_text":picker14_textFieldLabel1_text.trim(), "textField14_maxLength":fieldLength_14, "textField14_endorsment":endAdornment_14,
        "textField15_plh":textField15_plh, "picker15_textFieldLabel1_text":picker15_textFieldLabel1_text.trim(), "textField15_maxLength":fieldLength_15, "textField15_endorsment":endAdornment_15,
        "textField16_plh":textField16_plh, "picker16_textFieldLabel1_text":picker16_textFieldLabel1_text.trim(), "textField16_maxLength":fieldLength_16, "textField16_endorsment":endAdornment_16,
        "textField17_plh":textField17_plh, "picker17_textFieldLabel1_text":picker17_textFieldLabel1_text.trim(), "textField17_maxLength":fieldLength_17, "textField17_endorsment":endAdornment_17,
      });
      if(api.print_logs){console.log(methName+"step6");}

      if(api.print_logs){console.log(methName+"d2bCnt="+d2bCnt);}
      if(d2bCnt===0){
          //
          this.fieldNN_hide("10",0); this.fieldNN_hide("11",1); this.fieldNN_hide("12",2); this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7);
      }
      if(d2bCnt===1){
          this.fieldNN_show("10",0);
          this.fieldNN_hide("11",1); this.fieldNN_hide("12",2); this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7);
      }
      if(d2bCnt===2){
          this.fieldNN_show("10",0); this.fieldNN_show("11",1);
          this.fieldNN_hide("12",2); this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7);
      }
      if(d2bCnt===3){
          this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2);
          this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7);
      }
      if(d2bCnt===4){
          this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3);
          this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7);
      }
      if(d2bCnt===5){
          this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4);
          this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7);
      }
      if(d2bCnt===6){
          this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5);
          this.fieldNN_hide("16",6); this.fieldNN_hide("17",7);
      }
      if(d2bCnt===7){
          this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5); this.fieldNN_show("16",6);
          this.fieldNN_hide("17",7);
      }
      if(d2bCnt===7){
          this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5); this.fieldNN_show("16",6); this.fieldNN_show("17",7);
          //
      }
      if(api.print_logs){console.log(methName+"step7");}

      let currYear = parseInt((new Date()).getFullYear());

      let parserObject_getDays_TMP   = [];
      let parserObject_getMonths_TMP = [];
      let parserObject_getYears_TMP  = [];
      for(let i=1;        i<32;         ++i){parserObject_getDays_TMP.push(i.toString());}
      for(let i=1;        i<13;         ++i){parserObject_getMonths_TMP.push(i.toString());}
      for(let i=currYear; i<currYear+2; ++i){parserObject_getYears_TMP.push(i.toString());}
      this.setState({
        "parserObject_getDays10":parserObject_getDays_TMP, "parserObject_getMonths10":parserObject_getMonths_TMP, "parserObject_getYears10":parserObject_getYears_TMP,
        "parserObject_getDays11":parserObject_getDays_TMP, "parserObject_getMonths11":parserObject_getMonths_TMP, "parserObject_getYears11":parserObject_getYears_TMP,
        "parserObject_getDays12":parserObject_getDays_TMP, "parserObject_getMonths12":parserObject_getMonths_TMP, "parserObject_getYears12":parserObject_getYears_TMP,
        "parserObject_getDays13":parserObject_getDays_TMP, "parserObject_getMonths13":parserObject_getMonths_TMP, "parserObject_getYears13":parserObject_getYears_TMP,
        "parserObject_getDays14":parserObject_getDays_TMP, "parserObject_getMonths14":parserObject_getMonths_TMP, "parserObject_getYears14":parserObject_getYears_TMP,
        "parserObject_getDays15":parserObject_getDays_TMP, "parserObject_getMonths15":parserObject_getMonths_TMP, "parserObject_getYears15":parserObject_getYears_TMP,
        "parserObject_getDays16":parserObject_getDays_TMP, "parserObject_getMonths16":parserObject_getMonths_TMP, "parserObject_getYears16":parserObject_getYears_TMP,
        "parserObject_getDays17":parserObject_getDays_TMP, "parserObject_getMonths17":parserObject_getMonths_TMP, "parserObject_getYears17":parserObject_getYears_TMP,
      });


      if(this.isWebAppIOS12x()){
        setTimeout(function() {
          let sel = document.getElementById('root');
          sel.style.display='none';
          sel.style.display='flex';
        }.bind(), 250);
      }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  fieldNN_show(fn,ind){
    let fieldType = "";
    try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[ind]["clientType"]; }catch (err){ ; }
         if(fieldType === "ALPHANUM") { this.setState({ ["birthDate"+fn+"_isHidden"]:true,  ["picker"+fn+"_isHidden"]:true, ["textField"+fn+"_isHidden"]:false, ["textField"+fn+"_type"]:"text", ["textField"+fn+"_text"]:this.fillD2bField(ind), ["birthDateDay"+fn+"_text"]:"",                          ["birthDateMonth"+fn+"_text"]:"",                          ["birthDateYear"+fn+"_text"]:""                          }); }
    else if(fieldType === "DOUBLE")   { this.setState({ ["birthDate"+fn+"_isHidden"]:true,  ["picker"+fn+"_isHidden"]:true, ["textField"+fn+"_isHidden"]:false, ["textField"+fn+"_type"]:"text", ["textField"+fn+"_text"]:this.fillD2bField(ind), ["birthDateDay"+fn+"_text"]:"",                          ["birthDateMonth"+fn+"_text"]:"",                          ["birthDateYear"+fn+"_text"]:""                          }); }
    else if(fieldType === "DATE")     { this.setState({ ["birthDate"+fn+"_isHidden"]:false, ["picker"+fn+"_isHidden"]:true, ["textField"+fn+"_isHidden"]:true,  ["textField"+fn+"_type"]:"text", ["textField"+fn+"_text"]:"",                     ["birthDateDay"+fn+"_text"]:this.fillDateField("d",ind), ["birthDateMonth"+fn+"_text"]:this.fillDateField("m",ind), ["birthDateYear"+fn+"_text"]:this.fillDateField("y",ind) }); }
    else                              { }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  fieldNN_hide(fn,ind){
    this.setState({ ["picker"+fn+"_isHidden"]:true,  ["textField"+fn+"_isHidden"]:true});
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  fillD2bField(ind){
    let methName = filename+"fillD2bField ";
    if(api.print_logs){console.log(methName);}

    let parserObject_bills_payment_info_generic_res = null;
    try{ parserObject_bills_payment_info_generic_res = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_res")); } catch(err){;}
    //repeat transaction
    if(parserObject_bills_payment_info_generic_res!==null){
        let fieldName = "";
        let ws_id     = 0;
        try{ fieldName = this.state.parserObject_bills_payment_info_generic_res[ind]["name"]; }catch (err){ ; }
        try{ ws_id     = this.state.parserObject_bills_payment_info_generic_res[ind]["id"];   }catch (err){ ; }
        if(fieldName  === null || (typeof fieldName  ==="undefined")){fieldName  = "";}
        if(ws_id      === null || (typeof ws_id      ==="undefined")){ws_id      = 0;}
        if(api.print_logs){console.log(methName+"fieldName="+fieldName+",ind="+ind+",id="+ws_id);}

        for(let i=0; i<this.state.parserObject_bills_payment_info_generic_res.length; ++i){
            let fieldName_TMP  = "";
            let fieldValue_TMP = "";
            let fieldType_TMP  = "";
            let id_TMP         = 0;
            try{ fieldName_TMP  = this.state.parserObject_bills_payment_info_generic_res[i]["name"];       }catch (err){ ; }
            try{ fieldValue_TMP = this.state.parserObject_bills_payment_info_generic_res[i]["value"];      }catch (err){ ; }
            try{ fieldType_TMP  = this.state.parserObject_bills_payment_info_generic_res[i]["clientType"]; }catch (err){ ; }
            try{ id_TMP         = this.state.parserObject_bills_payment_info_generic_res[i]["id"];         }catch (err){ ; }
            if(fieldName_TMP  === null || (typeof fieldName_TMP  ==="undefined")){fieldName_TMP  = "";}
            if(fieldValue_TMP === null || (typeof fieldValue_TMP ==="undefined")){fieldValue_TMP = "";}
            if(fieldType_TMP  === null || (typeof fieldType_TMP  ==="undefined")){fieldType_TMP  = "";}
            if(ws_id===id_TMP){
                if(api.print_logs){console.log(methName+"fieldName_TMP="+fieldName_TMP+" fieldValue_TMP="+fieldValue_TMP+" fieldType_TMP="+fieldType_TMP);}
                if(api.print_logs){console.log(methName+"fieldName="+fieldName+" fieldValue_TMP="+fieldValue_TMP);}
                if(fieldType_TMP === "DOUBLE"){
                  fieldValue_TMP = fieldValue_TMP.replace(/\./g,",")
                }
                return fieldValue_TMP.trim();
            }
        }
    }
    return "";
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  fillDateField(dmy,ind){
    let methName = filename+"fillDateField ";
    if(api.print_logs){console.log(methName);}

    let parserObject_bills_payment_info_generic_res = null;
    try{ parserObject_bills_payment_info_generic_res = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_res")); } catch(err){;}
    //repeat transaction
    if(parserObject_bills_payment_info_generic_res!==null){
        let fieldName = "";
        try{ fieldName = this.state.parserObject_bills_payment_info_generic_res[ind]["name"]; }catch (err){ ; }
        if(fieldName  === null || (typeof fieldName  ==="undefined")){fieldName  = "";}
        if(api.print_logs){console.log(methName+"fieldName="+fieldName+",ind="+ind);}

        for(let i=0; i<this.state.parserObject_bills_payment_info_generic_res.length; ++i){
            let fieldName_TMP  = "";
            let fieldValue_TMP = "";
            let fieldType_TMP  = "";
            try{ fieldName_TMP  = this.state.parserObject_bills_payment_info_generic_res[i]["name"];       }catch (err){ ; }
            try{ fieldValue_TMP = this.state.parserObject_bills_payment_info_generic_res[i]["value"];      }catch (err){ ; }
            try{ fieldType_TMP  = this.state.parserObject_bills_payment_info_generic_res[i]["clientType"]; }catch (err){ ; }
            if(fieldName_TMP  === null || (typeof fieldName_TMP  ==="undefined")){fieldName_TMP  = "";}
            if(fieldValue_TMP === null || (typeof fieldValue_TMP ==="undefined")){fieldValue_TMP = "";}
            if(fieldType_TMP  === null || (typeof fieldType_TMP  ==="undefined")){fieldType_TMP  = "";}
            if(fieldName===fieldName_TMP){
                if(api.print_logs){console.log(methName+"dmy="+dmy+" fieldName_TMP="+fieldName_TMP+" fieldValue_TMP="+fieldValue_TMP+" fieldType_TMP="+fieldType_TMP+" fieldName="+fieldName);}
                let fieldValue_TMP_arr = fieldValue_TMP.split("/");
                if(dmy==="d"){ return (typeof fieldValue_TMP_arr[0] === "undefined") ? "" : fieldValue_TMP_arr[0]; }
                if(dmy==="m"){ return (typeof fieldValue_TMP_arr[1] === "undefined") ? "" : fieldValue_TMP_arr[1]; }
                if(dmy==="y"){ return (typeof fieldValue_TMP_arr[2] === "undefined") ? "" : fieldValue_TMP_arr[2]; }
                return "";
            }
        }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  onListItemClick_card(obj){
    let methName = filename+"onListItemClick_card ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //-------------
    //expired check
    //-------------
    for(var jj=0; jj<this.state.parserObject_cards.length; ++jj){
      if(this.state.parserObject_cards[jj].token===obj.token && this.state.parserObject_cards[jj].expired===true){
        this.dialog_handleOpen(this.NSInforString("BillsPaymentSetup_msg_cardExpired"));
        return;
      }
    }

    var parserObject_cards_TMP = JSON.parse(JSON.stringify(this.state.parserObject_cards));
    for(var i=0; i<parserObject_cards_TMP.length; ++i){
      parserObject_cards_TMP[i].preSelected = false;
    }
    for(var j=0; j<parserObject_cards_TMP.length; ++j){
      if(parserObject_cards_TMP[j].token===obj.token){
        parserObject_cards_TMP[j].preSelected = true;
      }
    }

    this.setState({"parserObject_cards":parserObject_cards_TMP, "checkBox_newCard":false});

    localStorage.setItem("payWithCardMethod", "payWithCardMethod_Tokenized");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
    localStorage.setItem("parserObject_selectedTokenizedCard", JSON.stringify(obj));
  }
  //----------------------------------------------------------------------------------------------------
  onListItemClick_newCard(obj){
    let methName = filename+"onListItemClick_newCard ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    var parserObject_cards_TMP = JSON.parse(JSON.stringify(this.state.parserObject_cards));
    for(var i=0; i<parserObject_cards_TMP.length; ++i){
      parserObject_cards_TMP[i].preSelected = false;
    }
    //for(var j=0; j<parserObject_cards_TMP.length; ++j){
    //  if(parserObject_cards_TMP[j].token===obj.token){
    //    parserObject_cards_TMP[j].preSelected = true;
    //  }
    //}

    this.setState({"parserObject_cards":parserObject_cards_TMP, "checkBox_newCard":true});

    localStorage.setItem("payWithCardMethod", "payWithCardMethod_Normal");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
    localStorage.setItem("parserObject_selectedTokenizedCard", {});
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_cardType_FromObj(obj){
    if(obj){
      return obj.cardType;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_cardNumMasked_FromObj(obj){
    if(obj){
      return obj.cardNumMasked;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_expDatetime_FromObj(obj){
    if(obj){
      return obj.expDatetime.replace('-', '/');
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateDayNN(event,value,index) {
    let methName = filename+"handleCustomDropDownClick_birthDateDayNN ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    if(index===10){this.setState({ "birthDateDay10_text":eventTMP, "birthDateDay10_hasError" : false,"birthDateMonth10_hasError" : false, "birthDateYear10_hasError" : false  });}
    if(index===11){this.setState({ "birthDateDay11_text":eventTMP, "birthDateDay11_hasError" : false,"birthDateMonth11_hasError" : false, "birthDateYear11_hasError" : false  });}
    if(index===12){this.setState({ "birthDateDay12_text":eventTMP, "birthDateDay12_hasError" : false,"birthDateMonth12_hasError" : false, "birthDateYear12_hasError" : false  });}
    if(index===13){this.setState({ "birthDateDay13_text":eventTMP, "birthDateDay13_hasError" : false,"birthDateMonth13_hasError" : false, "birthDateYear13_hasError" : false  });}
    if(index===14){this.setState({ "birthDateDay14_text":eventTMP, "birthDateDay14_hasError" : false,"birthDateMonth14_hasError" : false, "birthDateYear14_hasError" : false  });}
    if(index===15){this.setState({ "birthDateDay15_text":eventTMP, "birthDateDay15_hasError" : false,"birthDateMonth15_hasError" : false, "birthDateYear15_hasError" : false  });}
    if(index===16){this.setState({ "birthDateDay16_text":eventTMP, "birthDateDay16_hasError" : false,"birthDateMonth16_hasError" : false, "birthDateYear16_hasError" : false  });}
    if(index===17){this.setState({ "birthDateDay17_text":eventTMP, "birthDateDay17_hasError" : false,"birthDateMonth17_hasError" : false, "birthDateYear17_hasError" : false  });}
    this.checkBirthDate(index,"day",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateMonthNN(event,value,index) {
    let methName = filename+"handleCustomDropDownClick_birthDateMonthNN ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    if(index===10){this.setState({ "birthDateMonth10_text":eventTMP, "birthDateDay10_hasError" : false,"birthDateMonth10_hasError" : false, "birthDateYear10_hasError" : false  });}
    if(index===11){this.setState({ "birthDateMonth11_text":eventTMP, "birthDateDay11_hasError" : false,"birthDateMonth11_hasError" : false, "birthDateYear11_hasError" : false  });}
    if(index===12){this.setState({ "birthDateMonth12_text":eventTMP, "birthDateDay12_hasError" : false,"birthDateMonth12_hasError" : false, "birthDateYear12_hasError" : false  });}
    if(index===13){this.setState({ "birthDateMonth13_text":eventTMP, "birthDateDay13_hasError" : false,"birthDateMonth13_hasError" : false, "birthDateYear13_hasError" : false  });}
    if(index===14){this.setState({ "birthDateMonth14_text":eventTMP, "birthDateDay14_hasError" : false,"birthDateMonth14_hasError" : false, "birthDateYear14_hasError" : false  });}
    if(index===15){this.setState({ "birthDateMonth15_text":eventTMP, "birthDateDay15_hasError" : false,"birthDateMonth15_hasError" : false, "birthDateYear15_hasError" : false  });}
    if(index===16){this.setState({ "birthDateMonth16_text":eventTMP, "birthDateDay16_hasError" : false,"birthDateMonth16_hasError" : false, "birthDateYear16_hasError" : false  });}
    if(index===17){this.setState({ "birthDateMonth17_text":eventTMP, "birthDateDay17_hasError" : false,"birthDateMonth17_hasError" : false, "birthDateYear17_hasError" : false  });}
    this.checkBirthDate(index,"month",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_birthDateYearNN(event,value,index) {
    let methName = filename+"handleCustomDropDownClick_birthDateYearNN ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    if(index===10){this.setState({ "birthDateYear10_text":eventTMP, "birthDateDay10_hasError" : false,"birthDateMonth10_hasError" : false, "birthDateYear10_hasError" : false  });}
    if(index===11){this.setState({ "birthDateYear11_text":eventTMP, "birthDateDay11_hasError" : false,"birthDateMonth11_hasError" : false, "birthDateYear11_hasError" : false  });}
    if(index===12){this.setState({ "birthDateYear12_text":eventTMP, "birthDateDay12_hasError" : false,"birthDateMonth12_hasError" : false, "birthDateYear12_hasError" : false  });}
    if(index===13){this.setState({ "birthDateYear13_text":eventTMP, "birthDateDay13_hasError" : false,"birthDateMonth13_hasError" : false, "birthDateYear13_hasError" : false  });}
    if(index===14){this.setState({ "birthDateYear14_text":eventTMP, "birthDateDay14_hasError" : false,"birthDateMonth14_hasError" : false, "birthDateYear14_hasError" : false  });}
    if(index===15){this.setState({ "birthDateYear15_text":eventTMP, "birthDateDay15_hasError" : false,"birthDateMonth15_hasError" : false, "birthDateYear15_hasError" : false  });}
    if(index===16){this.setState({ "birthDateYear16_text":eventTMP, "birthDateDay16_hasError" : false,"birthDateMonth16_hasError" : false, "birthDateYear16_hasError" : false  });}
    if(index===17){this.setState({ "birthDateYear17_text":eventTMP, "birthDateDay17_hasError" : false,"birthDateMonth17_hasError" : false, "birthDateYear17_hasError" : false  });}
    this.checkBirthDate(index,"year",eventTMP);
  }
  //----------------------------------------------------------------------------------------------------
  checkBirthDate(index,lastSelected_key,lastSelected_val){
    let methName = filename+"checkBirthDate ";

    let dddd_TMP = "";
    let mmmm_TMP = "";
    let yyyy_TMP = "";
    if(index === 10){
      if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth10_text === "" || this.state.birthDateYear10_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth10_text; yyyy_TMP = this.state.birthDateYear10_text;  }
      if(lastSelected_key==="month"){ if(this.state.birthDateDay10_text   === "" || this.state.birthDateYear10_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay10_text;   yyyy_TMP = this.state.birthDateYear10_text;  }
      if(lastSelected_key==="year" ){ if(this.state.birthDateDay10_text   === "" || this.state.birthDateMonth10_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay10_text;   mmmm_TMP = this.state.birthDateMonth10_text; }
    }
    if(index === 11){
      if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth11_text === "" || this.state.birthDateYear11_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth11_text; yyyy_TMP = this.state.birthDateYear11_text;  }
      if(lastSelected_key==="month"){ if(this.state.birthDateDay11_text   === "" || this.state.birthDateYear11_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay11_text;   yyyy_TMP = this.state.birthDateYear11_text;  }
      if(lastSelected_key==="year" ){ if(this.state.birthDateDay11_text   === "" || this.state.birthDateMonth11_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay11_text;   mmmm_TMP = this.state.birthDateMonth11_text; }
    }
    if(index === 12){
      if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth12_text === "" || this.state.birthDateYear12_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth12_text; yyyy_TMP = this.state.birthDateYear12_text;  }
      if(lastSelected_key==="month"){ if(this.state.birthDateDay12_text   === "" || this.state.birthDateYear12_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay12_text;   yyyy_TMP = this.state.birthDateYear12_text;  }
      if(lastSelected_key==="year" ){ if(this.state.birthDateDay12_text   === "" || this.state.birthDateMonth12_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay12_text;   mmmm_TMP = this.state.birthDateMonth12_text; }
    }
    if(index === 13){
      if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth13_text === "" || this.state.birthDateYear13_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth13_text; yyyy_TMP = this.state.birthDateYear13_text;  }
      if(lastSelected_key==="month"){ if(this.state.birthDateDay13_text   === "" || this.state.birthDateYear13_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay13_text;   yyyy_TMP = this.state.birthDateYear13_text;  }
      if(lastSelected_key==="year" ){ if(this.state.birthDateDay13_text   === "" || this.state.birthDateMonth13_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay13_text;   mmmm_TMP = this.state.birthDateMonth13_text; }
    }
    if(index === 14){
      if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth14_text === "" || this.state.birthDateYear14_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth14_text; yyyy_TMP = this.state.birthDateYear14_text;  }
      if(lastSelected_key==="month"){ if(this.state.birthDateDay14_text   === "" || this.state.birthDateYear14_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay14_text;   yyyy_TMP = this.state.birthDateYear14_text;  }
      if(lastSelected_key==="year" ){ if(this.state.birthDateDay14_text   === "" || this.state.birthDateMonth14_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay14_text;   mmmm_TMP = this.state.birthDateMonth14_text; }
    }
    if(index === 15){
      if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth15_text === "" || this.state.birthDateYear15_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth15_text; yyyy_TMP = this.state.birthDateYear15_text;  }
      if(lastSelected_key==="month"){ if(this.state.birthDateDay15_text   === "" || this.state.birthDateYear15_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay15_text;   yyyy_TMP = this.state.birthDateYear15_text;  }
      if(lastSelected_key==="year" ){ if(this.state.birthDateDay15_text   === "" || this.state.birthDateMonth15_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay15_text;   mmmm_TMP = this.state.birthDateMonth15_text; }
    }
    if(index === 16){
      if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth16_text === "" || this.state.birthDateYear16_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth16_text; yyyy_TMP = this.state.birthDateYear16_text;  }
      if(lastSelected_key==="month"){ if(this.state.birthDateDay16_text   === "" || this.state.birthDateYear16_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay16_text;   yyyy_TMP = this.state.birthDateYear16_text;  }
      if(lastSelected_key==="year" ){ if(this.state.birthDateDay16_text   === "" || this.state.birthDateMonth16_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay16_text;   mmmm_TMP = this.state.birthDateMonth16_text; }
    }
    if(index === 17){
      if(lastSelected_key==="day"  ){ if(this.state.birthDateMonth17_text === "" || this.state.birthDateYear17_text  === ""){ return; } dddd_TMP = lastSelected_val; mmmm_TMP = this.state.birthDateMonth17_text; yyyy_TMP = this.state.birthDateYear17_text;  }
      if(lastSelected_key==="month"){ if(this.state.birthDateDay17_text   === "" || this.state.birthDateYear17_text  === ""){ return; } mmmm_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay17_text;   yyyy_TMP = this.state.birthDateYear17_text;  }
      if(lastSelected_key==="year" ){ if(this.state.birthDateDay17_text   === "" || this.state.birthDateMonth17_text === ""){ return; } yyyy_TMP = lastSelected_val; dddd_TMP = this.state.birthDateDay17_text;   mmmm_TMP = this.state.birthDateMonth17_text; }
    }

    console.log(methName+"dddd_TMP="+dddd_TMP);
    console.log(methName+"mmmm_TMP="+mmmm_TMP);
    console.log(methName+"yyyy_TMP="+yyyy_TMP);
    let isValidDate = this.isValidDate(yyyy_TMP,mmmm_TMP,dddd_TMP); //console.log("isValidDate="+isValidDate);
    if(isValidDate===false){
      if(api.print_logs){console.log(methName+"isValidDate="+isValidDate);}
      if(index === 10){this.setState({"birthDateDay10_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });}
      if(index === 11){this.setState({"birthDateDay11_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });}
      if(index === 12){this.setState({"birthDateDay12_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });}
      if(index === 13){this.setState({"birthDateDay13_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });}
      if(index === 14){this.setState({"birthDateDay14_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });}
      if(index === 15){this.setState({"birthDateDay15_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });}
      if(index === 16){this.setState({"birthDateDay16_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });}
      if(index === 17){this.setState({"birthDateDay17_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });}
      this.dialog_handleOpen(this.NSInforString("NotValidDate"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    /*
    let yyyy = yyyy_TMP;
    let mmmm = mmmm_TMP.length===1 ? "0"+mmmm_TMP : mmmm_TMP;
    let dddd = dddd_TMP.length===1 ? "0"+dddd_TMP : dddd_TMP;
    let birthdate = "";
    birthdate = yyyy+"-"+mmmm+"-"+dddd;
    try{
      let d1 = new Date(); d1.setFullYear( d1.getFullYear() - 18 );
      let d2 = new Date(birthdate);
      if(d1.getTime() < d2.getTime()){
        this.setState({"birthDateDay_hasError" : true,"birthDateMonth_hasError" : true, "birthDateYear_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("birthdate_error_age"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    } catch(err){
      console.log(methName+"err="+err);
    }*/
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    // if(this.verifyLength(this.state.textField1,1)===false){ return true; } //firstName
    // if(this.verifyLength(this.state.textField2,1)===false){ return true; } //lastName

    // if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
    //     let d2bCnt = this.state.parserObject_bills_payment_info_generic_res.length;
    //     let required_10 = false; if(d2bCnt>0){ try{ required_10 = this.state.parserObject_bills_payment_info_generic_res[0]["required"]; }catch(err){ ; } }
    //     let required_11 = false; if(d2bCnt>1){ try{ required_11 = this.state.parserObject_bills_payment_info_generic_res[1]["required"]; }catch(err){ ; } }
    //     let required_12 = false; if(d2bCnt>2){ try{ required_12 = this.state.parserObject_bills_payment_info_generic_res[2]["required"]; }catch(err){ ; } }
    //     let required_13 = false; if(d2bCnt>3){ try{ required_13 = this.state.parserObject_bills_payment_info_generic_res[3]["required"]; }catch(err){ ; } }
    //     let required_14 = false; if(d2bCnt>4){ try{ required_14 = this.state.parserObject_bills_payment_info_generic_res[4]["required"]; }catch(err){ ; } }
    //     let required_15 = false; if(d2bCnt>5){ try{ required_15 = this.state.parserObject_bills_payment_info_generic_res[5]["required"]; }catch(err){ ; } }
    //     let required_16 = false; if(d2bCnt>6){ try{ required_16 = this.state.parserObject_bills_payment_info_generic_res[6]["required"]; }catch(err){ ; } }
    //     let required_17 = false; if(d2bCnt>7){ try{ required_17 = this.state.parserObject_bills_payment_info_generic_res[7]["required"]; }catch(err){ ; } }
    //
    //          if(this.state.textField10_isHidden===false && (this.state.textField10_text === "") && required_10){ return true; }
    //     else if(this.state.textField11_isHidden===false && (this.state.textField11_text === "") && required_11){ return true; }
    //     else if(this.state.textField12_isHidden===false && (this.state.textField12_text === "") && required_12){ return true; }
    //     else if(this.state.textField13_isHidden===false && (this.state.textField13_text === "") && required_13){ return true; }
    //     else if(this.state.textField14_isHidden===false && (this.state.textField14_text === "") && required_14){ return true; }
    //     else if(this.state.textField15_isHidden===false && (this.state.textField15_text === "") && required_15){ return true; }
    //     else if(this.state.textField16_isHidden===false && (this.state.textField16_text === "") && required_16){ return true; }
    //     else if(this.state.textField17_isHidden===false && (this.state.textField17_text === "") && required_17){ return true; }
    //
    // }
    
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  TopRight_scan_act(event) {
    let methName = filename+"TopRight_scan_act ";
    if(api.print_logs){console.log(methName);}

    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    //history.push(wu_Utilities.getNavigationURLs("BillsScanner"));
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;

      let d2bCnt = this.state.parserObject_bills_payment_info_generic_res.length;
      let required_10 = false; if(d2bCnt>0){ try{ required_10 = this.state.parserObject_bills_payment_info_generic_res[0]["required"];  }catch(err){ ; } }
      let required_11 = false; if(d2bCnt>1){ try{ required_11 = this.state.parserObject_bills_payment_info_generic_res[1]["required"];  }catch(err){ ; } }
      let required_12 = false; if(d2bCnt>2){ try{ required_12 = this.state.parserObject_bills_payment_info_generic_res[2]["required"];  }catch(err){ ; } }
      let required_13 = false; if(d2bCnt>3){ try{ required_13 = this.state.parserObject_bills_payment_info_generic_res[3]["required"];  }catch(err){ ; } }
      let required_14 = false; if(d2bCnt>4){ try{ required_14 = this.state.parserObject_bills_payment_info_generic_res[4]["required"];  }catch(err){ ; } }
      let required_15 = false; if(d2bCnt>5){ try{ required_15 = this.state.parserObject_bills_payment_info_generic_res[5]["required"];  }catch(err){ ; } }
      let required_16 = false; if(d2bCnt>6){ try{ required_16 = this.state.parserObject_bills_payment_info_generic_res[6]["required"];  }catch(err){ ; } }
      let required_17 = false; if(d2bCnt>7){ try{ required_17 = this.state.parserObject_bills_payment_info_generic_res[7]["required"];  }catch(err){ ; } }

      if(this.state.textField10_isHidden===false && (this.state.textField10_text === "") && required_10){ this.setState({"textField10_hasError":true}); emptyFields = true; }
      if(this.state.textField11_isHidden===false && (this.state.textField11_text === "") && required_11){ this.setState({"textField11_hasError":true}); emptyFields = true; }
      if(this.state.textField12_isHidden===false && (this.state.textField12_text === "") && required_12){ this.setState({"textField12_hasError":true}); emptyFields = true; }
      if(this.state.textField13_isHidden===false && (this.state.textField13_text === "") && required_13){ this.setState({"textField13_hasError":true}); emptyFields = true; }
      if(this.state.textField14_isHidden===false && (this.state.textField14_text === "") && required_14){ this.setState({"textField14_hasError":true}); emptyFields = true; }
      if(this.state.textField15_isHidden===false && (this.state.textField15_text === "") && required_15){ this.setState({"textField15_hasError":true}); emptyFields = true; }
      if(this.state.textField16_isHidden===false && (this.state.textField16_text === "") && required_16){ this.setState({"textField16_hasError":true}); emptyFields = true; }
      if(this.state.textField17_isHidden===false && (this.state.textField17_text === "") && required_17){ this.setState({"textField17_hasError":true}); emptyFields = true; }

      if(this.state.birthDate10_isHidden === false){
        if(api.print_logs){console.log(methName+"this.state.birthDate10_isHidden===false");}
        if(this.state.birthDateDay10_text   === ""){ this.setState({"birthDateDay10_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth10_text === ""){ this.setState({"birthDateMonth10_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear10_text  === ""){ this.setState({"birthDateYear10_hasError"  : true }); emptyFields = true; }
      }
      if(this.state.birthDate11_isHidden === false){
        if(this.state.birthDateDay11_text   === ""){ this.setState({"birthDateDay11_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth11_text === ""){ this.setState({"birthDateMonth11_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear11_text  === ""){ this.setState({"birthDateYear11_hasError"  : true }); emptyFields = true; }
      }
      if(this.state.birthDate12_isHidden === false){
        if(api.print_logs){console.log(methName+"this.state.birthDate12_isHidden===false");}
        if(this.state.birthDateDay12_text   === ""){ this.setState({"birthDateDay12_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth12_text === ""){ this.setState({"birthDateMonth12_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear12_text  === ""){ this.setState({"birthDateYear12_hasError"  : true }); emptyFields = true; }
      }
      if(this.state.birthDate13_isHidden === false){
        if(api.print_logs){console.log(methName+"this.state.birthDate13_isHidden===false");}
        if(this.state.birthDateDay13_text   === ""){ this.setState({"birthDateDay13_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth13_text === ""){ this.setState({"birthDateMonth13_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear13_text  === ""){ this.setState({"birthDateYear13_hasError"  : true }); emptyFields = true; }
      }
      if(this.state.birthDate14_isHidden === false){
        if(api.print_logs){console.log(methName+"this.state.birthDate14_isHidden===false");}
        if(this.state.birthDateDay14_text   === ""){ this.setState({"birthDateDay14_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth14_text === ""){ this.setState({"birthDateMonth14_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear14_text  === ""){ this.setState({"birthDateYear14_hasError"  : true }); emptyFields = true; }
      }
      if(this.state.birthDate15_isHidden === false){
        if(api.print_logs){console.log(methName+"this.state.birthDate15_isHidden===false");}
        if(this.state.birthDateDay15_text   === ""){ this.setState({"birthDateDay15_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth15_text === ""){ this.setState({"birthDateMonth15_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear15_text  === ""){ this.setState({"birthDateYear15_hasError"  : true }); emptyFields = true; }
      }
      if(this.state.birthDate16_isHidden === false){
        if(api.print_logs){console.log(methName+"this.state.birthDate16_isHidden===false");}
        if(this.state.birthDateDay16_text   === ""){ this.setState({"birthDateDay16_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth16_text === ""){ this.setState({"birthDateMonth16_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear16_text  === ""){ this.setState({"birthDateYear16_hasError"  : true }); emptyFields = true; }
      }
      if(this.state.birthDate17_isHidden === false){
        if(api.print_logs){console.log(methName+"this.state.birthDate17_isHidden===false");}
        if(this.state.birthDateDay17_text   === ""){ this.setState({"birthDateDay17_hasError"   : true }); emptyFields = true; }
        if(this.state.birthDateMonth17_text === ""){ this.setState({"birthDateMonth17_hasError" : true }); emptyFields = true; }
        if(this.state.birthDateYear17_text  === ""){ this.setState({"birthDateYear17_hasError"  : true }); emptyFields = true; }
      }

      if(this.state.parserObject_cards && this.state.parserObject_cards.length>0){
        var foundSelection = false;
        for(var i=0; i<this.state.parserObject_cards.length; ++i){
          if(this.state.parserObject_cards[i].preSelected === true){
            var obj = this.state.parserObject_cards[i];
            localStorage.setItem("payWithCardMethod", "payWithCardMethod_Tokenized");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
            localStorage.setItem("parserObject_selectedTokenizedCard", JSON.stringify(obj));
            foundSelection = true;
          }
        }
        if(foundSelection===false && this.state.checkBox_newCard===true){
          localStorage.setItem("payWithCardMethod", "payWithCardMethod_Normal");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
          localStorage.setItem("parserObject_selectedTokenizedCard", {});
          foundSelection = true;
        }
        if(foundSelection===false){emptyFields=true;}
      }

      if(emptyFields===true){return;}
    }

    let d2bCnt = this.state.parserObject_bills_payment_info_generic_res.length;
    let required_10 = false; if(d2bCnt>0) { try{ required_10 = this.state.parserObject_bills_payment_info_generic_res[0]["required"];  }catch(err){ ; } }
    let required_11 = false; if(d2bCnt>1) { try{ required_11 = this.state.parserObject_bills_payment_info_generic_res[1]["required"];  }catch(err){ ; } }
    let required_12 = false; if(d2bCnt>2) { try{ required_12 = this.state.parserObject_bills_payment_info_generic_res[2]["required"];  }catch(err){ ; } }
    let required_13 = false; if(d2bCnt>3) { try{ required_13 = this.state.parserObject_bills_payment_info_generic_res[3]["required"];  }catch(err){ ; } }
    let required_14 = false; if(d2bCnt>4) { try{ required_14 = this.state.parserObject_bills_payment_info_generic_res[4]["required"];  }catch(err){ ; } }
    let required_15 = false; if(d2bCnt>5) { try{ required_15 = this.state.parserObject_bills_payment_info_generic_res[5]["required"];  }catch(err){ ; } }
    let required_16 = false; if(d2bCnt>6) { try{ required_16 = this.state.parserObject_bills_payment_info_generic_res[6]["required"];  }catch(err){ ; } }
    let required_17 = false; if(d2bCnt>7) { try{ required_17 = this.state.parserObject_bills_payment_info_generic_res[7]["required"];  }catch(err){ ; } }

    let fieldLength_10 = 0; if(d2bCnt>0) { try{ fieldLength_10 = parseInt(this.state.parserObject_bills_payment_info_generic_res[0]["length"]);  }catch(err){ fieldLength_10 = 0; } }
    let fieldLength_11 = 0; if(d2bCnt>1) { try{ fieldLength_11 = parseInt(this.state.parserObject_bills_payment_info_generic_res[1]["length"]);  }catch(err){ fieldLength_11 = 0; } }
    let fieldLength_12 = 0; if(d2bCnt>2) { try{ fieldLength_12 = parseInt(this.state.parserObject_bills_payment_info_generic_res[2]["length"]);  }catch(err){ fieldLength_12 = 0; } }
    let fieldLength_13 = 0; if(d2bCnt>3) { try{ fieldLength_13 = parseInt(this.state.parserObject_bills_payment_info_generic_res[3]["length"]);  }catch(err){ fieldLength_13 = 0; } }
    let fieldLength_14 = 0; if(d2bCnt>4) { try{ fieldLength_14 = parseInt(this.state.parserObject_bills_payment_info_generic_res[4]["length"]);  }catch(err){ fieldLength_14 = 0; } }
    let fieldLength_15 = 0; if(d2bCnt>5) { try{ fieldLength_15 = parseInt(this.state.parserObject_bills_payment_info_generic_res[5]["length"]);  }catch(err){ fieldLength_15 = 0; } }
    let fieldLength_16 = 0; if(d2bCnt>6) { try{ fieldLength_16 = parseInt(this.state.parserObject_bills_payment_info_generic_res[6]["length"]);  }catch(err){ fieldLength_16 = 0; } }
    let fieldLength_17 = 0; if(d2bCnt>7) { try{ fieldLength_17 = parseInt(this.state.parserObject_bills_payment_info_generic_res[7]["length"]);  }catch(err){ fieldLength_17 = 0; } }

          if(this.state.textField10_isHidden===false && (this.state.textField10_text === "") && required_10){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField10_plh+"\""); return; }
     else if(this.state.textField11_isHidden===false && (this.state.textField11_text === "") && required_11){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField11_plh+"\""); return; }
     else if(this.state.textField12_isHidden===false && (this.state.textField12_text === "") && required_12){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField12_plh+"\""); return; }
     else if(this.state.textField13_isHidden===false && (this.state.textField13_text === "") && required_13){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField13_plh+"\""); return; }
     else if(this.state.textField14_isHidden===false && (this.state.textField14_text === "") && required_14){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField14_plh+"\""); return; }
     else if(this.state.textField15_isHidden===false && (this.state.textField15_text === "") && required_15){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField15_plh+"\""); return; }
     else if(this.state.textField16_isHidden===false && (this.state.textField16_text === "") && required_16){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField16_plh+"\""); return; }
     else if(this.state.textField17_isHidden===false && (this.state.textField17_text === "") && required_17){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField17_plh+"\""); return; }

         if(this.state.textField10_isHidden===false && (this.state.textField10_text.length>fieldLength_10) && required_10 && fieldLength_10>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_10+"")); return; }
    else if(this.state.textField11_isHidden===false && (this.state.textField11_text.length>fieldLength_11) && required_11 && fieldLength_11>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_11+"")); return; }
    else if(this.state.textField12_isHidden===false && (this.state.textField12_text.length>fieldLength_12) && required_12 && fieldLength_12>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_12+"")); return; }
    else if(this.state.textField13_isHidden===false && (this.state.textField13_text.length>fieldLength_13) && required_13 && fieldLength_13>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_13+"")); return; }
    else if(this.state.textField14_isHidden===false && (this.state.textField14_text.length>fieldLength_14) && required_14 && fieldLength_14>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_14+"")); return; }
    else if(this.state.textField15_isHidden===false && (this.state.textField15_text.length>fieldLength_15) && required_15 && fieldLength_15>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_15+"")); return; }
    else if(this.state.textField16_isHidden===false && (this.state.textField16_text.length>fieldLength_16) && required_16 && fieldLength_16>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_16+"")); return; }
    else if(this.state.textField17_isHidden===false && (this.state.textField17_text.length>fieldLength_17) && required_17 && fieldLength_17>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_17+"")); return; }

    let fieldType10 = ""; try{ fieldType10 = this.state.parserObject_bills_payment_info_generic_res[0]["clientType"]; }catch (err){ ; } //console.log("fieldType10="+fieldType10);//zzz
    let fieldType11 = ""; try{ fieldType11 = this.state.parserObject_bills_payment_info_generic_res[1]["clientType"]; }catch (err){ ; } //console.log("fieldType11="+fieldType11);
    let fieldType12 = ""; try{ fieldType12 = this.state.parserObject_bills_payment_info_generic_res[2]["clientType"]; }catch (err){ ; } //console.log("fieldType12="+fieldType12);
    let fieldType13 = ""; try{ fieldType13 = this.state.parserObject_bills_payment_info_generic_res[3]["clientType"]; }catch (err){ ; } //console.log("fieldType13="+fieldType13);
    let fieldType14 = ""; try{ fieldType14 = this.state.parserObject_bills_payment_info_generic_res[4]["clientType"]; }catch (err){ ; } //console.log("fieldType14="+fieldType14);
    let fieldType15 = ""; try{ fieldType15 = this.state.parserObject_bills_payment_info_generic_res[5]["clientType"]; }catch (err){ ; } //console.log("fieldType15="+fieldType15);
    let fieldType16 = ""; try{ fieldType16 = this.state.parserObject_bills_payment_info_generic_res[6]["clientType"]; }catch (err){ ; } //console.log("fieldType16="+fieldType16);
    let fieldType17 = ""; try{ fieldType17 = this.state.parserObject_bills_payment_info_generic_res[7]["clientType"]; }catch (err){ ; } //console.log("fieldType17="+fieldType17);

    let regex10 = ""; let regex10Var = null; try{ regex10 = this.state.parserObject_bills_payment_info_generic_res[0]["regex"]; regex10Var = new RegExp(regex10,'g'); }catch (err){ ; } //console.log("regex10="+regex10);//
    let regex11 = ""; let regex11Var = null; try{ regex11 = this.state.parserObject_bills_payment_info_generic_res[1]["regex"]; regex11Var = new RegExp(regex11,'g'); }catch (err){ ; } //console.log("regex11="+regex11);
    let regex12 = ""; let regex12Var = null; try{ regex12 = this.state.parserObject_bills_payment_info_generic_res[2]["regex"]; regex12Var = new RegExp(regex12,'g'); }catch (err){ ; } //console.log("regex12="+regex12);
    let regex13 = ""; let regex13Var = null; try{ regex13 = this.state.parserObject_bills_payment_info_generic_res[3]["regex"]; regex13Var = new RegExp(regex13,'g'); }catch (err){ ; } //console.log("regex13="+regex13);
    let regex14 = ""; let regex14Var = null; try{ regex14 = this.state.parserObject_bills_payment_info_generic_res[4]["regex"]; regex14Var = new RegExp(regex14,'g'); }catch (err){ ; } //console.log("regex14="+regex14);
    let regex15 = ""; let regex15Var = null; try{ regex15 = this.state.parserObject_bills_payment_info_generic_res[5]["regex"]; regex15Var = new RegExp(regex15,'g'); }catch (err){ ; } //console.log("regex15="+regex15);
    let regex16 = ""; let regex16Var = null; try{ regex16 = this.state.parserObject_bills_payment_info_generic_res[6]["regex"]; regex16Var = new RegExp(regex16,'g'); }catch (err){ ; } //console.log("regex16="+regex16);
    let regex17 = ""; let regex17Var = null; try{ regex17 = this.state.parserObject_bills_payment_info_generic_res[7]["regex"]; regex17Var = new RegExp(regex17,'g'); }catch (err){ ; } //console.log("regex17="+regex17);

    // if(this.state.textField10_isHidden===false && fieldType10==="ALPHANUM" && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField10_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField10_plh+"\" "+this.NSInforString("with_latin")); return; }
    // if(this.state.textField11_isHidden===false && fieldType11==="ALPHANUM" && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField11_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField11_plh+"\" "+this.NSInforString("with_latin")); return; }
    // if(this.state.textField12_isHidden===false && fieldType12==="ALPHANUM" && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField12_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField12_plh+"\" "+this.NSInforString("with_latin")); return; }
    // if(this.state.textField13_isHidden===false && fieldType13==="ALPHANUM" && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField13_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField13_plh+"\" "+this.NSInforString("with_latin")); return; }
    // if(this.state.textField14_isHidden===false && fieldType14==="ALPHANUM" && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField14_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField14_plh+"\" "+this.NSInforString("with_latin")); return; }
    // if(this.state.textField15_isHidden===false && fieldType15==="ALPHANUM" && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField15_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField15_plh+"\" "+this.NSInforString("with_latin")); return; }
    // if(this.state.textField16_isHidden===false && fieldType16==="ALPHANUM" && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField16_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField16_plh+"\" "+this.NSInforString("with_latin")); return; }
    // if(this.state.textField17_isHidden===false && fieldType17==="ALPHANUM" && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField17_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField17_plh+"\" "+this.NSInforString("with_latin")); return; }

    if(this.state.textField10_isHidden===false && fieldType10==="DOUBLE" && wu_Utilities.validateFloatString(this.state.textField10_text.replace(/ /g,"").replace(/,/g,"."))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField10_plh+"\" "+this.NSInforString("with_number")); this.setState({"textField10_hasError":true}); return; }
    if(this.state.textField11_isHidden===false && fieldType11==="DOUBLE" && wu_Utilities.validateFloatString(this.state.textField11_text.replace(/ /g,"").replace(/,/g,"."))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField11_plh+"\" "+this.NSInforString("with_number")); this.setState({"textField11_hasError":true}); return; }
    if(this.state.textField12_isHidden===false && fieldType12==="DOUBLE" && wu_Utilities.validateFloatString(this.state.textField12_text.replace(/ /g,"").replace(/,/g,"."))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField12_plh+"\" "+this.NSInforString("with_number")); this.setState({"textField12_hasError":true}); return; }
    if(this.state.textField13_isHidden===false && fieldType13==="DOUBLE" && wu_Utilities.validateFloatString(this.state.textField13_text.replace(/ /g,"").replace(/,/g,"."))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField13_plh+"\" "+this.NSInforString("with_number")); this.setState({"textField13_hasError":true}); return; }
    if(this.state.textField14_isHidden===false && fieldType14==="DOUBLE" && wu_Utilities.validateFloatString(this.state.textField14_text.replace(/ /g,"").replace(/,/g,"."))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField14_plh+"\" "+this.NSInforString("with_number")); this.setState({"textField14_hasError":true}); return; }
    if(this.state.textField15_isHidden===false && fieldType15==="DOUBLE" && wu_Utilities.validateFloatString(this.state.textField15_text.replace(/ /g,"").replace(/,/g,"."))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField15_plh+"\" "+this.NSInforString("with_number")); this.setState({"textField15_hasError":true}); return; }
    if(this.state.textField16_isHidden===false && fieldType16==="DOUBLE" && wu_Utilities.validateFloatString(this.state.textField16_text.replace(/ /g,"").replace(/,/g,"."))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField16_plh+"\" "+this.NSInforString("with_number")); this.setState({"textField16_hasError":true}); return; }
    if(this.state.textField17_isHidden===false && fieldType17==="DOUBLE" && wu_Utilities.validateFloatString(this.state.textField17_text.replace(/ /g,"").replace(/,/g,"."))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField17_plh+"\" "+this.NSInforString("with_number")); this.setState({"textField17_hasError":true}); return; }

    if(this.state.textField10_isHidden===false && regex10!=="" && this.state.textField10_text.replace(/ /g,"").match(regex10Var)+""!==this.state.textField10_text.replace(/ /g,"")){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField10_plh+"\" "+this.NSInforString("with_input")); this.setState({"textField10_hasError":true}); return; }
    if(this.state.textField11_isHidden===false && regex11!=="" && this.state.textField11_text.replace(/ /g,"").match(regex11Var)+""!==this.state.textField11_text.replace(/ /g,"")){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField11_plh+"\" "+this.NSInforString("with_input")); this.setState({"textField11_hasError":true}); return; }
    if(this.state.textField12_isHidden===false && regex12!=="" && this.state.textField12_text.replace(/ /g,"").match(regex12Var)+""!==this.state.textField12_text.replace(/ /g,"")){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField12_plh+"\" "+this.NSInforString("with_input")); this.setState({"textField12_hasError":true}); return; }
    if(this.state.textField13_isHidden===false && regex13!=="" && this.state.textField13_text.replace(/ /g,"").match(regex13Var)+""!==this.state.textField13_text.replace(/ /g,"")){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField13_plh+"\" "+this.NSInforString("with_input")); this.setState({"textField13_hasError":true}); return; }
    if(this.state.textField14_isHidden===false && regex14!=="" && this.state.textField14_text.replace(/ /g,"").match(regex14Var)+""!==this.state.textField14_text.replace(/ /g,"")){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField14_plh+"\" "+this.NSInforString("with_input")); this.setState({"textField14_hasError":true}); return; }
    if(this.state.textField15_isHidden===false && regex15!=="" && this.state.textField15_text.replace(/ /g,"").match(regex15Var)+""!==this.state.textField15_text.replace(/ /g,"")){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField15_plh+"\" "+this.NSInforString("with_input")); this.setState({"textField15_hasError":true}); return; }
    if(this.state.textField16_isHidden===false && regex16!=="" && this.state.textField16_text.replace(/ /g,"").match(regex16Var)+""!==this.state.textField16_text.replace(/ /g,"")){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField16_plh+"\" "+this.NSInforString("with_input")); this.setState({"textField16_hasError":true}); return; }
    if(this.state.textField17_isHidden===false && regex17!=="" && this.state.textField17_text.replace(/ /g,"").match(regex17Var)+""!==this.state.textField17_text.replace(/ /g,"")){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField17_plh+"\" "+this.NSInforString("with_input")); this.setState({"textField17_hasError":true}); return; }
     //----------------
     //validate date 10---Multi Picker
     //----------------
     if(this.state.birthDate10_isHidden === false){
       if(this.isValidDate(this.state.birthDateYear10_text,this.state.birthDateMonth10_text,this.state.birthDateDay10_text)===false){
         this.setState({"birthDateDay10_hasError" : true,"birthDateMonth10_hasError" : true, "birthDateYear10_hasError" : true });
         this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
         return;
       }
     }
     //----------------
     //validate date 11---Multi Picker
     //----------------
     if(this.state.birthDate11_isHidden === false){
       if(this.isValidDate(this.state.birthDateYear11_text,this.state.birthDateMonth11_text,this.state.birthDateDay11_text)===false){
         this.setState({"birthDateDay11_hasError" : true,"birthDateMonth11_hasError" : true, "birthDateYear11_hasError" : true });
         this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
         return;
       }
     }
     //----------------
     //validate date 12---Multi Picker
     //----------------
     if(this.state.birthDate12_isHidden === false){
       if(this.isValidDate(this.state.birthDateYear12_text,this.state.birthDateMonth12_text,this.state.birthDateDay12_text)===false){
         this.setState({"birthDateDay12_hasError" : true,"birthDateMonth12_hasError" : true, "birthDateYear12_hasError" : true });
         this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
         return;
       }
     }
     //----------------
     //validate date 13---Multi Picker
     //----------------
     if(this.state.birthDate13_isHidden === false){
       if(this.isValidDate(this.state.birthDateYear13_text,this.state.birthDateMonth13_text,this.state.birthDateDay13_text)===false){
         this.setState({"birthDateDay13_hasError" : true,"birthDateMonth13_hasError" : true, "birthDateYear13_hasError" : true });
         this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
         return;
       }
     }
     //----------------
     //validate date 14---Multi Picker
     //----------------
     if(this.state.birthDate14_isHidden === false){
       if(this.isValidDate(this.state.birthDateYear14_text,this.state.birthDateMonth14_text,this.state.birthDateDay14_text)===false){
         this.setState({"birthDateDay14_hasError" : true,"birthDateMonth14_hasError" : true, "birthDateYear14_hasError" : true });
         this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
         return;
       }
     }
     //----------------
     //validate date 15---Multi Picker
     //----------------
     if(this.state.birthDate15_isHidden === false){
       if(this.isValidDate(this.state.birthDateYear15_text,this.state.birthDateMonth15_text,this.state.birthDateDay15_text)===false){
         this.setState({"birthDateDay15_hasError" : true,"birthDateMonth15_hasError" : true, "birthDateYear15_hasError" : true });
         this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
         return;
       }
     }
     //----------------
     //validate date 16---Multi Picker
     //----------------
     if(this.state.birthDate16_isHidden === false){
       if(this.isValidDate(this.state.birthDateYear16_text,this.state.birthDateMonth16_text,this.state.birthDateDay16_text)===false){
         this.setState({"birthDateDay16_hasError" : true,"birthDateMonth16_hasError" : true, "birthDateYear16_hasError" : true });
         this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
         return;
       }
     }
     //----------------
     //validate date 17---Multi Picker
     //----------------
     if(this.state.birthDate17_isHidden === false){
       if(this.isValidDate(this.state.birthDateYear17_text,this.state.birthDateMonth17_text,this.state.birthDateDay17_text)===false){
         this.setState({"birthDateDay17_hasError" : true,"birthDateMonth17_hasError" : true, "birthDateYear17_hasError" : true });
         this.dialog_handleOpen(this.NSInforString("emtpy_field")+this.NSInforString("SettingsProfilePersonal_plh07"));
         return;
       }
     }



    event.preventDefault();
    this.makeHTTPConn_next();
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_next(){
      let methName = filename+"makeHTTPConn_next ";
      if(api.print_logs){console.log(methName);}

      //[Lockers]
      if( this.isLockersActive() ){ return; }
      else                        { this.startLockers(); }

      //--------------------------------------------------
      //enrich parserObject_bills_payment_info_generic_res
      //--------------------------------------------------
      var parserObject_bills_payment_info_generic_res = JSON.parse(JSON.stringify(this.state.parserObject_bills_payment_info_generic_res));
      if(parserObject_bills_payment_info_generic_res.length > 0){
          let ind = 0;
          let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[ind]));
          item_new["value"] = item_new["clientType"]==="DATE" ? this.getDateFromPage(10) : this.state.textField10_text;
          parserObject_bills_payment_info_generic_res[ind] = item_new;
      }
      if(parserObject_bills_payment_info_generic_res.length > 1){
          let ind = 1;
          let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[ind]));
          item_new["value"] = item_new["clientType"]==="DATE" ? this.getDateFromPage(11) : this.state.textField11_text;
          parserObject_bills_payment_info_generic_res[ind] = item_new;
      }
      if(parserObject_bills_payment_info_generic_res.length > 2){
          let ind = 2;
          let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[ind]));
          item_new["value"] = item_new["clientType"]==="DATE" ? this.getDateFromPage(12) : this.state.textField12_text;
          parserObject_bills_payment_info_generic_res[ind] = item_new;
      }
      if(parserObject_bills_payment_info_generic_res.length > 3){
          let ind = 3;
          let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[ind]));
          item_new["value"] = item_new["clientType"]==="DATE" ? this.getDateFromPage(13) : this.state.textField13_text;
          parserObject_bills_payment_info_generic_res[ind] = item_new;
      }
      if(parserObject_bills_payment_info_generic_res.length > 4){
          let ind = 4;
          let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[ind]));
          item_new["value"] = item_new["clientType"]==="DATE" ? this.getDateFromPage(14) : this.state.textField14_text;
          parserObject_bills_payment_info_generic_res[ind] = item_new;
      }
      if(parserObject_bills_payment_info_generic_res.length > 5){
          let ind = 5;
          let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[ind]));
          item_new["value"] = item_new["clientType"]==="DATE" ? this.getDateFromPage(15) : this.state.textField15_text;
          parserObject_bills_payment_info_generic_res[ind] = item_new;
      }
      if(parserObject_bills_payment_info_generic_res.length > 6){
          let ind = 6;
          let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[ind]));
          item_new["value"] = item_new["clientType"]==="DATE" ? this.getDateFromPage(16) : this.state.textField16_text;
          parserObject_bills_payment_info_generic_res[ind] = item_new;
      }
      if(parserObject_bills_payment_info_generic_res.length > 7){
          let ind = 7;
          let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[ind]));
          item_new["value"] = item_new["clientType"]==="DATE" ? this.getDateFromPage(17) : this.state.textField17_text;
          parserObject_bills_payment_info_generic_res[ind] = item_new;
      }
      //------------------------
      //wu_bills_payment_getFees---Prepare Request
      //------------------------
      var ws_billId = 0;
      try{ ws_billId = parseInt(localStorage.getItem("bills_billerId"));}catch(err){console.log(methName+'err='+err);}

      var parserObject_bills_payment_getFees_req = {};
      parserObject_bills_payment_getFees_req["billerId"] = ws_billId;
      parserObject_bills_payment_getFees_req["amount"]   = this.getPaymentAmountFromTextfields(parserObject_bills_payment_info_generic_res);
      localStorage.setItem("parserObject_bills_payment_getFees_req",JSON.stringify(parserObject_bills_payment_getFees_req));

      this.startSpinners();
      setTimeout(function() { //Start the timer
        //------------------------
        //wu_bills_payment_getFees
        //------------------------
        wu_BillsService
        .wu_bills_payment_getFees(parserObject_bills_payment_getFees_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="BillsPaymentSetup"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          //this.stopLockers();this.stopSpinners();
          localStorage.setItem("parserObject_bills_payment_getFees_res", JSON.stringify(res.charges));
          var parserObject_bills_payment_getFees_res = res.charges;

          //--------------------------------------------------
          //enrich parserObject_bills_payment_info_generic_aux
          //--------------------------------------------------
          var ws_charge = 0.0;
          let aItem1 = parserObject_bills_payment_getFees_res[0];
          try {ws_charge = aItem1["charge"]; }catch(err){;} if(ws_charge === null || (typeof ws_charge ==="undefined")){ws_charge = 0.0;}

          var parserObject_bills_payment_info_generic_aux = [];
          for(let i=0; i<parserObject_bills_payment_info_generic_res.length; ++i){
              let aItem = parserObject_bills_payment_info_generic_res[i];
              var ws_clientType = "";
              var ws_type       = "";
              try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
              try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
              if(ws_clientType === "DOUBLE" && ws_type === "AMOUNT"){
                  let item_old = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[i]));
                  item_old["name"]  = aItem["name"];
                  item_old["type"]  = aItem["type"];
                  item_old["value"] = this.getPaymentAmountFromTextfields(parserObject_bills_payment_info_generic_res);
                  parserObject_bills_payment_info_generic_aux.push(item_old);

                  let item_new = JSON.parse(JSON.stringify(parserObject_bills_payment_info_generic_res[i]));
                  item_new["name"]  = localStorage.getItem("lang")==="el" ? "Τέλη Συναλλαγής" : "Fees";
                  item_new["type"]  = "FEES";
                  item_new["value"] = String(ws_charge);//"100";
                  parserObject_bills_payment_info_generic_aux.push(item_new);
              }
              else{
                  parserObject_bills_payment_info_generic_aux.push(aItem);
              }
          }
          localStorage.setItem("parserObject_bills_payment_info_generic_aux", JSON.stringify(parserObject_bills_payment_info_generic_aux));
          //----------------------------
          //bills_payment_validateFields---prepare
          //----------------------------
          let amount   = wu_Utilities.bills_getPaymentAmount();      if(api.print_logs){console.log(methName+"amount   = " + amount);}
          let fees     = wu_Utilities.bills_getPaymentFees();        if(api.print_logs){console.log(methName+"fees     = " + fees);}
          let gross_f1 = amount + fees;                              if(api.print_logs){console.log(methName+"gross_f1 = " + gross_f1);}
        //let gross_f2 = parseFloat(Math.floor(100 * gross_f1)/100); if(api.print_logs){console.log(methName+"gross_f2 = " + gross_f2);}
          let gross_f2 = parseFloat(100 * gross_f1/100);             if(api.print_logs){console.log(methName+"gross_f2 = " + gross_f2);}
          var parserObject_bills_payment_validateFields_req = {};
          parserObject_bills_payment_validateFields_req["billerID"]       = ws_billId;
          parserObject_bills_payment_validateFields_req["charges"]        = String(fees);
          parserObject_bills_payment_validateFields_req["gross"]          = String(gross_f2.toFixed(2));

          let fieldValues = [];
          for(let i=0; i<parserObject_bills_payment_info_generic_aux.length; ++i){
              let item = parserObject_bills_payment_info_generic_aux[i];
              let ws_type  = "";
              let ws_value = "";
              let ws_id    = 0;
              try{ ws_type  = item["type"];  }catch (err){ ws_type  = ""; }
              try{ ws_value = item["value"]; }catch (err){ ws_value = ""; }
              try{ ws_id    = item["id"];    }catch (err){ ws_id    = 0;  }
              let item_new = {};
              item_new["fieldValue"] = ws_value;
              item_new["fieldId"]    = ws_id;
              if((ws_type === "FEES") === false){
                  fieldValues.push(item_new);
              }
          }
          parserObject_bills_payment_validateFields_req["fieldValues"] = fieldValues;
          //-------------------------------
          //wu_bills_payment_validateFields
          //-------------------------------
          wu_BillsService
          .wu_bills_payment_validateFields(parserObject_bills_payment_validateFields_req)
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="BillsPaymentSetup"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            this.stopLockers();this.stopSpinners();

            //+++++++++++++++
            //Goto Controller
            //+++++++++++++++
            localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
            history.push(wu_Utilities.getNavigationURLs("BillsPaymentReview"));
          })
          .catch(err => {
            this.stopLockers();this.stopSpinners();
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){
              if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
              if(err.returnCode===-200){ this.setState({ "textField5_isHidden":false}); return; }
              this.dialog_handleOpen(err.returnText,"NET");
            }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
          });
        })
        .catch(err => {
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){
            if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
            if(err.returnCode===-200){ this.setState({ "textField5_isHidden":false}); return; }
            this.dialog_handleOpen(err.returnText,"NET");
          }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });

      }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+event.target.value);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField10_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[0]["clientType"]; }catch (err){ ; }
      if(fieldType==="DOUBLE"){eventTMP = this.maskaPoswn(eventTMP);} //console.log("0 fieldType="+fieldType);
      let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_bills_payment_info_generic_res[0]["length"]); }catch (err){ fieldLength = 0; }
      this.setState({ "textField10_hasError" : (eventTMP.trim() === "") ? true : false, "textField10_text":(eventTMP+"").toUpperCase() });
      //if(fieldType==="ALPHANUM" && eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField10_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField10_hasError":true}); return; }
    }
    else if(stateVar==="textField11_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[1]["clientType"]; }catch (err){ ; }
      if(fieldType==="DOUBLE"){eventTMP = this.maskaPoswn(eventTMP);} //console.log("1 fieldType="+fieldType);
      let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_bills_payment_info_generic_res[1]["length"]); }catch (err){ fieldLength = 0; }
      this.setState({ "textField11_hasError" : (eventTMP.trim() === "") ? true : false, "textField11_text":(eventTMP+"").toUpperCase() });
      //if(fieldType==="ALPHANUM" && eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField11_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField11_hasError":true}); return; }
    }
    else if(stateVar==="textField12_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[2]["clientType"]; }catch (err){ ; }
      if(fieldType==="DOUBLE"){eventTMP = this.maskaPoswn(eventTMP);} //console.log("2 fieldType="+fieldType);
      let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_bills_payment_info_generic_res[2]["length"]); }catch (err){ fieldLength = 0; }
      this.setState({ "textField12_hasError" : (eventTMP.trim() === "") ? true : false, "textField12_text":(eventTMP+"").toUpperCase() });
      //f(fieldType==="ALPHANUM" && eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField12_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField12_hasError":true}); return; }
    }
    else if(stateVar==="textField13_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[3]["clientType"]; }catch (err){ ; }
      if(fieldType==="DOUBLE"){eventTMP = this.maskaPoswn(eventTMP);} //console.log("3 fieldType="+fieldType);
      let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_bills_payment_info_generic_res[3]["length"]); }catch (err){ fieldLength = 0; }
      this.setState({ "textField13_hasError" : (eventTMP.trim() === "") ? true : false, "textField13_text":(eventTMP+"").toUpperCase() });
      //if(fieldType==="ALPHANUM" && eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField13_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField13_hasError":true}); return; }
    }
    else if(stateVar==="textField14_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[4]["clientType"]; }catch (err){ ; }
      if(fieldType==="DOUBLE"){eventTMP = this.maskaPoswn(eventTMP);} //console.log("4 fieldType="+fieldType);
      let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_bills_payment_info_generic_res[4]["length"]); }catch (err){ fieldLength = 0; }
      this.setState({ "textField14_hasError" : (eventTMP.trim() === "") ? true : false, "textField14_text":(eventTMP+"").toUpperCase() });
      //if(fieldType==="ALPHANUM" && eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField14_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField14_hasError":true}); return; }
    }
    else if(stateVar==="textField15_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[5]["clientType"]; }catch (err){ ; }
      if(fieldType==="DOUBLE"){eventTMP = this.maskaPoswn(eventTMP);} //console.log("5 fieldType="+fieldType);
      let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_bills_payment_info_generic_res[5]["length"]); }catch (err){ fieldLength = 0; }
      this.setState({ "textField15_hasError" : (eventTMP.trim() === "") ? true : false, "textField15_text":(eventTMP+"").toUpperCase() });
      //if(fieldType==="ALPHANUM" && eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField15_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField15_hasError":true}); return; }
    }
    else if(stateVar==="textField16_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[6]["clientType"]; }catch (err){ ; }
      if(fieldType==="DOUBLE"){eventTMP = this.maskaPoswn(eventTMP);} //console.log("6 fieldType="+fieldType);
      let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_bills_payment_info_generic_res[6]["length"]); }catch (err){ fieldLength = 0; }
      this.setState({ "textField16_hasError" : (eventTMP.trim() === "") ? true : false, "textField16_text":(eventTMP+"").toUpperCase() });
      //if(fieldType==="ALPHANUM" && eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField16_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField16_hasError":true}); return; }
    }
    else if(stateVar==="textField17_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[7]["clientType"]; }catch (err){ ; }
      if(fieldType==="DOUBLE"){eventTMP = this.maskaPoswn(eventTMP);} //console.log("7 fieldType="+fieldType);
      let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_bills_payment_info_generic_res[7]["length"]); }catch (err){ fieldLength = 0; }
      this.setState({ "textField17_hasError" : (eventTMP.trim() === "") ? true : false, "textField17_text":(eventTMP+"").toUpperCase() });
      //if(fieldType==="ALPHANUM" && eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField17_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField17_hasError":true}); return; }
    }
    else{
      this.setState({ [stateVar] : event.target.value });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  NSInforString_withLang(aKey,lang){
    if(lang==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else           { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email")                            { return wu_Utilities.wu_verifyEmail(val); }
    if(key==="MTCN")                             { return wu_Utilities.wu_verifyMTCN(val);  }

    return false;
  }
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //https://stackoverflow.com/questions/21188420/javascript-date-validation-not-validation-february-31
  isValidDate(year, month, day) {
    let methName = filename+"isValidDate ";
    if(api.print_logs){console.log(methName);}

    try{
      let year_int  = parseInt(year);
      let month_int = parseInt(month)-1;
      let day_int   = parseInt(day);
      var d = new Date(year_int, month_int, day_int);
      //console.log(methName+"d.getFullYear()="+d.getFullYear()+" year_int="+year_int);
      //console.log(methName+"d.getMonth()   ="+d.getMonth()+"    month_int="+month_int);
      //console.log(methName+"d.getDate()    ="+d.getDate()+"     day_int="+day_int);
      if (d.getFullYear() === year_int && d.getMonth() === month_int && d.getDate() === day_int) {
          return true;
      }
    }catch(err){
      console.log(methName+"err="+err)
      return false;
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  process_CategoriesCompaniesObject(){
    let methName = filename+"process_CategoriesCompaniesObject ";
    if(api.print_logs){console.log(methName);}

    let categoryFieldDescr = localStorage.getItem("lang")==="el" ? "categoryEl" : "categoryEn";
    var parserObject_categoriesList = [];
    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
       let aItem = parserObject_categoriesCompaniesList[i];
       let category   = "";
       var categoryEl = "";
       var categoryEn = "";
       var mid        = 0;
       try {category   = aItem[categoryFieldDescr]; }catch(err){;} if(category   === null || (typeof category   ==="undefined")){category   = "";}
       try {categoryEl = aItem["categoryEl"];       }catch(err){;} if(categoryEl === null || (typeof categoryEl ==="undefined")){categoryEl = "";}
       try {categoryEn = aItem["categoryEn"];       }catch(err){;} if(categoryEn === null || (typeof categoryEn ==="undefined")){categoryEn = "";}
       try {mid        = aItem["mid"];              }catch(err){;} if(mid        === null || (typeof mid        ==="undefined")){mid        = 0;}
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       if(wu_Utilities.bills_categoryExists(category, parserObject_categoriesList) === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = categoryEl;
           aCategory["categoryEn"] = categoryEn;
           aCategory["mid"]        = mid;
           parserObject_categoriesList.push(aCategory);
       }
    }

    parserObject_categoriesList.sort(function(a, b) {
      if( (a.category).localeCompare(b.category) === -1){ return -1; }
      if( (a.category).localeCompare(b.category) === 1){ return 1; }
      return 0;
    });

    var popularFound = false;
    for(var j=0; j<parserObject_categoriesCompaniesList.length; ++j){
       let aItem = parserObject_categoriesCompaniesList[j];
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       var popularity = 0;
       try {popularity = aItem["popularity"]; }catch(err){;} if(popularity === null || (typeof popularity ==="undefined")){popularity = 0;}
       let category = this.NSInforString("Bills_popular_category");
       if(popularity > 0 && popularFound === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = this.NSInforString_withLang("Bills_popular_category","el");
           aCategory["categoryEn"] = this.NSInforString_withLang("Bills_popular_category","en");
           aCategory["mid"]        = 1000000;
           parserObject_categoriesList.splice(0, 0, aCategory);//insert at index 0
           popularFound = true;
       }
    }

    this.setState({ "parserObject_categoriesList" : parserObject_categoriesList });
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  getPaymentAmountFromTextfields(parserObject_bills_payment_info_generic_res) {
      let methName = filename+"getPaymentAmountFromTextfields ";
      if(api.print_logs){console.log(methName);}

      for(var i=0; i<parserObject_bills_payment_info_generic_res.length; ++i){
          let aItem = parserObject_bills_payment_info_generic_res[i];
          var ws_clientType = "";
          var ws_type       = "";
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
          //print("i=\(i) \(textField3.text!) ws_clientType=\(ws_clientType) ws_type=\(ws_type)")
          if(ws_clientType === "DOUBLE" && ws_type === "AMOUNT"){
              if(i === 0){ return this.state.textField10_text.replace(/,/g,"."); }
              if(i === 1){ return this.state.textField11_text.replace(/,/g,"."); }
              if(i === 2){ return this.state.textField12_text.replace(/,/g,"."); }
              if(i === 3){ return this.state.textField13_text.replace(/,/g,"."); }
              if(i === 4){ return this.state.textField14_text.replace(/,/g,"."); }
              if(i === 5){ return this.state.textField15_text.replace(/,/g,"."); }
              if(i === 6){ return this.state.textField16_text.replace(/,/g,"."); }
              if(i === 7){ return this.state.textField17_text.replace(/,/g,"."); }
          }
      }
      return "0";
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  getFieldValueString(ind, fName){

      var result = "";
      var ws_clientType = "";
      var ws_type       = "";
      if(ind === 0 && this.state.parserObject_bills_payment_info_generic_res.length > 0){
          let aItem = this.state.parserObject_bills_payment_info_generic_res[ind];
          try{ result        = aItem[fName];        }catch (err){ result        = ""; }
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
      }
      if(ind === 1 && this.state.parserObject_bills_payment_info_generic_res.length > 1){
          let aItem = this.state.parserObject_bills_payment_info_generic_res[ind];
          try{ result        = aItem[fName];        }catch (err){ result        = ""; }
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
      }
      if(ind === 2 && this.state.parserObject_bills_payment_info_generic_res.length > 2){
          let aItem = this.state.parserObject_bills_payment_info_generic_res[ind];
          try{ result        = aItem[fName];        }catch (err){ result        = ""; }
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
      }
      if(ind === 3 && this.state.parserObject_bills_payment_info_generic_res.length > 3){
          let aItem = this.state.parserObject_bills_payment_info_generic_res[ind];
          try{ result        = aItem[fName];        }catch (err){ result        = ""; }
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
      }
      if(ind === 4 && this.state.parserObject_bills_payment_info_generic_res.length > 4){
          let aItem = this.state.parserObject_bills_payment_info_generic_res[ind];
          try{ result        = aItem[fName];        }catch (err){ result        = ""; }
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
      }
      if(ind === 5 && this.state.parserObject_bills_payment_info_generic_res.length > 5){
          let aItem = this.state.parserObject_bills_payment_info_generic_res[ind];
          try{ result        = aItem[fName];        }catch (err){ result        = ""; }
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
      }
      if(ind === 6 && this.state.parserObject_bills_payment_info_generic_res.length > 6){
          let aItem = this.state.parserObject_bills_payment_info_generic_res[ind];
          try{ result        = aItem[fName];        }catch (err){ result        = ""; }
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
      }
      if(ind === 7 && this.state.parserObject_bills_payment_info_generic_res.length > 7){
          let aItem = this.state.parserObject_bills_payment_info_generic_res[ind];
          try{ result        = aItem[fName];        }catch (err){ result        = ""; }
          try{ ws_clientType = aItem["clientType"]; }catch (err){ ws_clientType = ""; }
          try{ ws_type       = aItem["type"];       }catch (err){ ws_type       = ""; }
      }

      if(ws_clientType === "DOUBLE" && ws_type === "AMOUNT" && isNaN(result)===false){
          result = wu_Utilities.bills_normalizeAmount(result);
      }

      return result;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  getDateFromPage(ind){
    //----------------
    //validate date 10---Multi Picker
    //----------------
    if(ind === 10){
      let yyyy = this.state.birthDateYear10_text;
      let mmmm = this.state.birthDateMonth10_text.length===1 ? "0"+this.state.birthDateMonth10_text : this.state.birthDateMonth10_text;
      let dddd = this.state.birthDateDay10_text.length===1   ? "0"+this.state.birthDateDay10_text   : this.state.birthDateDay10_text;
      return dddd + "/" + mmmm + "/" + yyyy;
    }
    //----------------
    //validate date 11---Multi Picker
    //----------------
    if(ind === 11){
      let yyyy = this.state.birthDateYear11_text;
      let mmmm = this.state.birthDateMonth11_text.length===1 ? "0"+this.state.birthDateMonth11_text : this.state.birthDateMonth11_text;
      let dddd = this.state.birthDateDay11_text.length===1   ? "0"+this.state.birthDateDay11_text   : this.state.birthDateDay11_text;
      return dddd + "/" + mmmm + "/" + yyyy;
    }
    //----------------
    //validate date 12---Multi Picker
    //----------------
    if(ind === 12){
      let yyyy = this.state.birthDateYear12_text;
      let mmmm = this.state.birthDateMonth12_text.length===1 ? "0"+this.state.birthDateMonth12_text : this.state.birthDateMonth12_text;
      let dddd = this.state.birthDateDay12_text.length===1   ? "0"+this.state.birthDateDay12_text   : this.state.birthDateDay12_text;
      return dddd + "/" + mmmm + "/" + yyyy;
    }
    //----------------
    //validate date 13---Multi Picker
    //----------------
    if(ind === 13){
      let yyyy = this.state.birthDateYear13_text;
      let mmmm = this.state.birthDateMonth13_text.length===1 ? "0"+this.state.birthDateMonth13_text : this.state.birthDateMonth13_text;
      let dddd = this.state.birthDateDay13_text.length===1   ? "0"+this.state.birthDateDay13_text   : this.state.birthDateDay13_text;
      return dddd + "/" + mmmm + "/" + yyyy;
    }
    //----------------
    //validate date 14---Multi Picker
    //----------------
    if(ind === 14){
      let yyyy = this.state.birthDateYear14_text;
      let mmmm = this.state.birthDateMonth14_text.length===1 ? "0"+this.state.birthDateMonth14_text : this.state.birthDateMonth14_text;
      let dddd = this.state.birthDateDay14_text.length===1   ? "0"+this.state.birthDateDay14_text   : this.state.birthDateDay14_text;
      return dddd + "/" + mmmm + "/" + yyyy;
    }
    //----------------
    //validate date 15---Multi Picker
    //----------------
    if(ind === 15){
      let yyyy = this.state.birthDateYear15_text;
      let mmmm = this.state.birthDateMonth15_text.length===1 ? "0"+this.state.birthDateMonth15_text : this.state.birthDateMonth15_text;
      let dddd = this.state.birthDateDay15_text.length===1   ? "0"+this.state.birthDateDay15_text   : this.state.birthDateDay15_text;
      return dddd + "/" + mmmm + "/" + yyyy;
    }
    //----------------
    //validate date 16---Multi Picker
    //----------------
    if(ind === 16){
      let yyyy = this.state.birthDateYear16_text;
      let mmmm = this.state.birthDateMonth16_text.length===1 ? "0"+this.state.birthDateMonth16_text : this.state.birthDateMonth16_text;
      let dddd = this.state.birthDateDay16_text.length===1   ? "0"+this.state.birthDateDay16_text   : this.state.birthDateDay16_text;
      return dddd + "/" + mmmm + "/" + yyyy;
    }
    //----------------
    //validate date 17---Multi Picker
    //----------------
    if(ind === 17){
      let yyyy = this.state.birthDateYear17_text;
      let mmmm = this.state.birthDateMonth17_text.length===1 ? "0"+this.state.birthDateMonth17_text : this.state.birthDateMonth17_text;
      let dddd = this.state.birthDateDay17_text.length===1   ? "0"+this.state.birthDateDay17_text   : this.state.birthDateDay17_text;
      return dddd + "/" + mmmm + "/" + yyyy;
    }

    return "";
  }
  //----------------------------------------------------------------------------------------------------
  clear_cookies_not_needed(){
    let methName = filename+"clear_cookies_not_needed ";
    if(api.print_logs){console.log(methName);}

    try{
      //Cookies.remove('lang',                                  { path:api.webapp_path});
        Cookies.remove('isLoggedIn',                            { path:api.webapp_path});
        Cookies.remove('accessToken',                           { path:api.webapp_path});
        Cookies.remove('refreshToken',                          { path:api.webapp_path});
        Cookies.remove('tokenID',                               { path:api.webapp_path});
        Cookies.remove('transId',                               { path:api.webapp_path});
        Cookies.remove('billId',                                { path:api.webapp_path});
        Cookies.remove('bills_billsHistoryDetail_FLOW',         { path:api.webapp_path});
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    let methName = filename+"goBack ";
    if(api.print_logs){console.log(methName);}

    this.clear_cookies_not_needed();

    if(api.print_logs){console.log(methName+"prev_view="+localStorage.getItem("prev_view").trim());}
    if(api.print_logs){console.log(methName+"navi_view="+localStorage.getItem("BillsPaymentSetup_prev_view").trim());}
         if(localStorage.getItem("prev_view").trim()==="Bills")                { history.goBack();}
    else if(localStorage.getItem("prev_view").trim()==="BillsCategories")      { history.goBack();}
    else if(localStorage.getItem("prev_view").trim()==="BillsCompanies")       { history.goBack();}
    else if(localStorage.getItem("prev_view").trim()==="BillsFavoritesDetail") { history.goBack();}
    else if(localStorage.getItem("prev_view").trim()==="BillsHistoryDetail")   { history.goBack();}
    else if(localStorage.getItem("prev_view").trim()==="BillsScanner")         { history.goBack();}
    else{
      let zzz_prev_view = localStorage.getItem("BillsPaymentSetup_prev_view");
      if(zzz_prev_view===null || (typeof zzz_prev_view==="undefined")){zzz_prev_view = "";}
      zzz_prev_view = zzz_prev_view.trim()
      localStorage.setItem("BillsPaymentSetup_prev_view","");
           if(zzz_prev_view==="Bills")                { history.push(wu_Utilities.getNavigationURLs("Bills")); }
      else if(zzz_prev_view==="BillsCategories")      { history.push(wu_Utilities.getNavigationURLs("BillsCategories")); }
      else if(zzz_prev_view==="BillsCompanies")       { history.push(wu_Utilities.getNavigationURLs("BillsCompanies")); }
      else if(zzz_prev_view==="BillsFavoritesDetail") { history.push(wu_Utilities.getNavigationURLs("BillsFavoritesDetail")); }
      else if(zzz_prev_view==="BillsHistoryDetail")   { history.push(wu_Utilities.getNavigationURLs("BillsHistoryDetail")); }
    //else if(zzz_prev_view==="BillsScanner")         { history.push(wu_Utilities.getNavigationURLs("BillsScanner")); }
      else{
        //history.go(-1);
        history.goBack();
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG1"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( BillsPaymentSetup_continue_locked===true ){ return true;  }
    else                                          { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    BillsPaymentSetup_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    BillsPaymentSetup_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IE11----------------------------------------------
  //----------------------------------------------------------------------------------------------------
  IE11_not_loading_state_workaround(){
    let ua   = window.navigator.userAgent;
    let msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!ua.match(/Trident.*rv\:11\./)){
      let stateObj = {};
      let hasAField = false;
      if(this.state.textField1===""){ stateObj.textField1 = Cookies.get('rcv_fname'); hasAField = true; }
      if(this.state.textField2===""){ stateObj.textField2 = Cookies.get('rcv_lname'); hasAField = true; }
      if(hasAField===true){this.setState(stateObj);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IOS12---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  isWebAppIOS12x() {
    let methName = filename+"isWebAppIOS12x ";
    try{
      let ua = window.navigator.userAgent;
      if (/iP(hone|od|ad)/.test(ua)) {
        var v = (ua).match(/OS (\d+)_(\d+)_?(\d+)?/);
        //return parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10);
        console.log(methName+"iOS version="+parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10));
        if(parseInt(v[1], 10)===12){
          return true;
        }
      }
    }catch(err){
      console.log(methName+"err="+err);
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  maskaPoswn(eventTMP){
    //step-1
    eventTMP = eventTMP.replace(/[^\d,]/g, '');
    //step-2
    let count = (eventTMP.match(/,/g) || []).length;
    if(count>1){
      //console.log("count="+count);
      //eventTMP = eventTMP.replace(/\.\./g, '.');
      eventTMP = eventTMP.replace(',', '');
    }
    //step-3
    if(eventTMP.indexOf(",")>=0) {
      let NumOfDec = eventTMP.length-eventTMP.indexOf(",")-1;
      //console.log("NumOfDec="+NumOfDec);
      if(NumOfDec>2){
        eventTMP = eventTMP.substring(0, eventTMP.length-1);
      }
    }
    return eventTMP;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Various-------------------------------------------
  //----------------------------------------------------------------------------------------------------
  maskaPoswn_dot(eventTMP){
    //step-1
    eventTMP = eventTMP.replace(/[^\d.]/g, '');
    //step-2
    let count = (eventTMP.match(/\./g) || []).length;
    if(count>1){
      //console.log("count="+count);
      //eventTMP = eventTMP.replace(/\.\./g, '.');
      eventTMP = eventTMP.replace('.', '');
    }
    //step-3
    if(eventTMP.indexOf(".")>=0) {
      let NumOfDec = eventTMP.length-eventTMP.indexOf(".")-1;
      //console.log("NumOfDec="+NumOfDec);
      if(NumOfDec>2){
        eventTMP = eventTMP.substring(0, eventTMP.length-1);
      }
    }
    return eventTMP;
  }
  //----------------------------------------------------------------------------------------------------
}
BillsPaymentSetup.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(BillsPaymentSetupStyle)(BillsPaymentSetup)
);
